/**
 * Front-end JavaScript
 *
 * The JavaScript code you place here will be processed by esbuild. The output
 * file will be created at `../theme/js/script.min.js` and enqueued in
 * `../theme/functions.php`.
 *
 * For esbuild documentation, please see:
 * https://esbuild.github.io/
 */
/* global lottie */
import EmblaCarousel from 'embla-carousel';
import Fade from 'embla-carousel-fade';
import ClassNames from 'embla-carousel-class-names';
import { Modal, Ripple, initTWE } from 'tw-elements';
import { DateTime, Interval } from 'luxon';

initTWE({ Modal, Ripple });
import { addPrevNextBtnsClickHandlers } from './EmblaCarouselArrowButtons';
import { addDotBtnsAndClickHandlers } from './EmblaCarouselDotButton';

gsap.registerPlugin(ScrollTrigger, SplitText);
gsap.config({ nullTargetWarn: false });

// Polyfill requestIdleCallback for Safari (set globally by wp_head in functions.php)
const requestIdle = window.requestIdle;

/*
Lazy Load Images
 */
window.addEventListener('load', () => {
	document.querySelectorAll('img[data-src]').forEach((img) => {
		img.src = img.dataset.src;
	});
});

import datepicker from 'js-datepicker';

const dob = document.getElementById(`dob`);
if (dob) {
	dob.addEventListener('input', function (e) {
		let value = e.target.value;
		value = value.replace(/\D/g, ''); // Remove all non-numeric characters

		if (value.length > 2 && value.length <= 4) {
			value = value.slice(0, 2) + '/' + value.slice(2);
		} else if (value.length > 4) {
			value =
				value.slice(0, 2) +
				'/' +
				value.slice(2, 4) +
				'/' +
				value.slice(4, 8);
		}

		e.target.value = value;
	});
}

const OPTIONS = { loop: true, duration: 30 };

document.addEventListener('DOMContentLoaded', () => {
	const violatorClosed = document.querySelector('.violator-close');
	if (violatorClosed) {
		violatorClosed.addEventListener('click', function () {
			document.querySelector('.violator').classList.add('hidden');
		});
	}

	function toggleDropdown(button, dropdownClass) {
		let dropdown = document.querySelector(dropdownClass);

		if (dropdown.classList.contains('active')) {
			dropdown.style.transform = 'translate(0, -100%)';
			dropdown.classList.remove('active');
			button.classList.remove('is-active');
		} else {
			dropdown.style.transform = 'translate(0, 0)';
			dropdown.classList.add('active');
			button.classList.add('is-active');
		}
	}

	document.querySelectorAll('.action-dropdown').forEach((button) => {
		button.addEventListener('click', function (e) {
			e.preventDefault();
			toggleDropdown(this, '.mobile-dropdown');
		});
	});

	const emblaNodes = document.querySelectorAll('.embla');
	emblaNodes.forEach((emblaNode) => {
		const viewportNode = emblaNode.querySelector('.embla__viewport');
		const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
		const nextBtnNode = emblaNode.querySelector('.embla__button--next');
		const dotsNode = emblaNode.querySelector('.embla__dots');

		const emblaType = emblaNode.dataset.embla || '';

		let options = {
			align: 'center',
			loop: false,
		};

		const plugins = [];
		plugins.push(ClassNames());

		if (emblaType === 'grid-slider') {
			options = {
				align: 'start',
				containScroll: 'trimSnaps',
				slidesToScroll: 1,
				dragFree: true,
				loop: true,
			};
		} else {
			plugins.push(Fade());
		}

		const emblaApi = EmblaCarousel(viewportNode, options, plugins);

		const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
			emblaApi,
			prevBtnNode,
			nextBtnNode
		);
		const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
			emblaApi,
			dotsNode
		);

		emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
		emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
	});
});

window.toggleAccordion = function (index) {
	const content = document.getElementById(`content-${index}`);
	const icon = document.getElementById(`icon-${index}`);
	const group = document.getElementById(`accordion-group-${index}`);

	// SVG for Minus icon
	const minusSVG = `
			<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
			  <path d="M1 1L21 21" stroke="#454E5D" stroke-width="2" stroke-linecap="round"/>
			  <path d="M21 1L0.999998 21" stroke="#454E5D" stroke-width="2" stroke-linecap="round"/>
			</svg>`;

	// SVG for Plus icon
	const plusSVG = `
		<svg xmlns="http://www.w3.org/2000/svg" width="22" height="13" viewBox="0 0 22 13" fill="none">
		  <path opacity="0.5" d="M1 1L11 11L21 1" stroke="#5A6778" stroke-width="2" stroke-linecap="round"/>
		</svg>`;

	if (content.style.maxHeight && content.style.maxHeight !== '0px') {
		content.style.maxHeight = '0';
		icon.innerHTML = plusSVG;
		if (group) {
			group.classList.remove('active');
		}
	} else {
		content.style.maxHeight = content.scrollHeight + 'px';
		icon.innerHTML = minusSVG;
		if (group) {
			group.classList.add('active');
		}
	}
};

window.toggleLocation = function (index) {
	const content = document.getElementById(`content-${index}`);
	const parent = content.parentElement;
	window.toggleAccordion(index);
	const sibling = parent.parentElement.querySelector('.accordion-bg');
	parent.classList.toggle('bg-transparent');
	if (sibling) {
		sibling.toggleAttribute('hidden');
		sibling.classList.toggle('bg-transparent');
		sibling.classList.toggle('pointer-events-none');
	}
};

document.addEventListener('DOMContentLoaded', () => {
	const mm = gsap.matchMedia();

	document.querySelectorAll('.registration-card').forEach((button) => {
		let hoverElement = button.querySelector('.registration-card-hover');

		if (hoverElement) {
			mm.add('(prefers-reduced-motion: no-preference)', () => {
				gsap.to(hoverElement, {
					rotateZ: '+=360',
					duration: 3,
					ease: 'linear',
					repeat: -1,
				});
			});
		}
	});

	document.querySelectorAll('.event-card').forEach((button) => {
		let hoverElement = button.querySelector('.event-card-hover');

		if (hoverElement) {
			mm.add('(prefers-reduced-motion: no-preference)', () => {
				gsap.to(hoverElement, {
					rotateZ: '+=360',
					duration: 3,
					ease: 'linear',
					repeat: -1,
				});
			});
		}
	});

	/**
	 * FAQ Nav
	 */
	const sections = document.querySelectorAll('.faq-section[id]');
	const navLinks = document.querySelectorAll('.faq-menu a');

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					navLinks.forEach((link) => link.classList.remove('active'));
					const activeLink = document.querySelector(
						`a[href="#${entry.target.id}"]`
					);
					if (activeLink) {
						activeLink.classList.add('active');
					}
				}
			});
		},
		{
			root: null,
			rootMargin: '-20% 0px -20% 0px', // Triggers when the section is mostly in view
			threshold: 0.1,
		}
	);

	sections.forEach((section) => observer.observe(section));

	/**
	 * Video Modal
	 */
	const modals = document.querySelectorAll('[data-twe-modal-init]');

	modals.forEach((modal) => {
		const iframe = modal.querySelector("iframe[src*='vimeo.com']");
		const openButton = document.querySelector(
			`[data-twe-target="#${modal.id}"]`
		);
		const closeButton = modal.querySelector('[data-twe-modal-dismiss]');
		const videoContainer = modal.querySelector('.video-container'); // Reference to the video container

		if (iframe) {
			// It's a pre-rendered Vimeo player
			if (typeof Vimeo !== 'undefined' && Vimeo.Player) {
				const player = new Vimeo.Player(iframe);

				if (openButton) {
					openButton.addEventListener('click', function () {
						player.play();
					});
				}

				if (closeButton) {
					closeButton.addEventListener('click', function () {
						player.pause();
						document.activeElement.blur();
					});
				}
			}
		} else {
			// Dynamic video modal (TV block)
			if (openButton) {
				openButton.addEventListener('click', async function () {
					// Only load if iframe not already present
					if (!modal.querySelector('iframe')) {
						const videoId = modal.getAttribute('data-video-id');
						if (videoId) {
							await loadVimeoVideo(modal, videoId);
						}
					}
				});
			}

			if (closeButton) {
				closeButton.addEventListener('click', function () {
					// When modal closes, pause if player exists and reset container
					const loadedIframe = modal.querySelector('iframe');
					if (loadedIframe && typeof Vimeo !== 'undefined' && Vimeo.Player) {
						try {
							const player = new Vimeo.Player(loadedIframe);
							player.pause();
						} catch (e) { }
					}
					if (videoContainer) {
						videoContainer.innerHTML =
							'<p class="eyebrow text-center">Loading...</p>';
					}
					document.activeElement.blur();
				});
			}
		}
	});

	async function loadVimeoVideo(modal, videoId) {
		try {
			const response = await fetch(
				`${window.location.origin}/wp-content/themes/tutu/theme/vdo/get_video.php?video_id=${videoId}`
			);
			const data = await response.json();

			if (data && data.embed_url) {
				const iframeHTML = `<iframe src="${data.embed_url}" width="640" height="360" frameborder="0" allowfullscreen allow="autoplay; fullscreen; picture-in-picture; encrypted-media" class="aspect-video w-full h-full mt-10 rounded-[20px]"></iframe>`;
				const container = modal.querySelector('.video-container');
				if (container) {
					container.innerHTML = iframeHTML;
				}
			} else {
				console.error('Error loading Vimeo video data:', data);
			}
		} catch (error) {
			console.error('Error fetching Vimeo video data:', error);
		}
	}

	/**
	 * Dropdown
	 */
	function setupDropdown(button) {
		const menuId = button.getAttribute('data-menu');
		const menu = document.querySelector(`[data-menu-content='${menuId}']`);

		if (!menu) return;

		button.addEventListener('click', function () {
			const isExpanded = button.getAttribute('aria-expanded') === 'true';
			button.setAttribute('aria-expanded', !isExpanded);
			button.classList.toggle('active', !isExpanded);

			if (!isExpanded) {
				menu.style.maxHeight = menu.scrollHeight + 'px';
			} else {
				menu.style.maxHeight = '0px';
			}
		});

		document.addEventListener('click', function (event) {
			if (
				!button.contains(event.target) &&
				!menu.contains(event.target)
			) {
				menu.style.maxHeight = '0px';
				button.setAttribute('aria-expanded', 'false');
				button.classList.remove('active');
			}
		});
	}

	document.querySelectorAll('[data-menu]').forEach(setupDropdown);

	/**
	 * Background Color Switch
	 */
	function changeCSSVariables(newValues, duration = 0.5, ease = 'circ.out') {
		gsap.to(':root', {
			duration,
			ease,
			'--bg': newValues.bg,
			immediateRender: false,
		});
	}

	function createScrollTrigger(selector, enterColor, leaveColor) {
		const element = document.querySelector(selector);
		if (element) {
			ScrollTrigger.create({
				trigger: element,
				start: 'top center',
				onEnter: () => {
					changeCSSVariables({ bg: enterColor });
				},
				onLeaveBack: () => {
					changeCSSVariables({ bg: leaveColor });
				},
			});
		}
	}

	createScrollTrigger('.switch-neutral-purple', '#F3E8F4', '#FDF6F2');
	createScrollTrigger('.switch-purple-neutral', '#FDF6F2', '#F3E8F4');
	createScrollTrigger('.switch-neutral-pink', '#F8DFE4', '#FDF6F2');
	createScrollTrigger('.switch-pink-neutral', '#FDF6F2', '#F8DFE4');
	createScrollTrigger('.switch-neutral-yellow', '#FFF8D3', '#FDF6F2');
	createScrollTrigger('.switch-yellow-neutral', '#FDF6F2', '#FFF8D3');
	createScrollTrigger('.switch-neutral-periwinkle', '#F3EEFF', '#FDF6F2');
	createScrollTrigger('.switch-periwinkle-neutral', '#FDF6F2', '#F3EEFF');
	createScrollTrigger('.switch-neutral-baby-blue', '#F1F5FF', '#FDF6F2');
	createScrollTrigger('.switch-baby-blue-neutral', '#FDF6F2', '#F1F5FF');
	createScrollTrigger('.switch-summit-purple', '#C9BCE5', '#907CAF');
	createScrollTrigger('.switch-summit-light', '#F5E9F4', '#C9BCE5');
	createScrollTrigger('.switch-summit-dark', '#907CAF', '#F5E9F4');

	/**
	 * Hero Animation
	 */
	const heading = document.querySelectorAll('[data-split-words]');

	if (heading) {
		const hero = document.querySelector('.hero');
		const heroFade = document.querySelector('.hero-fade');
		const heroPromo = document.querySelector('.hero-promo');
		const timeline = gsap.timeline();

		heading.forEach((slide) => {
			// Apply GSAP SplitText
			const splitWords = new SplitText(slide, {
				types: 'chars, words',
				wordsClass: 'chars',
			});

			mm.add('(prefers-reduced-motion: no-preference)', () => {
				if (hero) {
					timeline.fromTo(
						hero,
						{ autoAlpha: 0, scale: 0.9 },
						{ autoAlpha: 1, scale: 1, duration: 0.5 }
					);
				}

				let split = new SplitText(slide, {
					type: 'chars, words',
				});
				if (split) {
					timeline.from(split.chars, {
						opacity: 0,
						y: 50,
						stagger: {
							from: 'start', //try "center" and "edges"
							each: 0.01,
						},
					});
				}

				if (heroFade) {
					timeline.fromTo(
						heroFade,
						{ y: 40, opacity: 0 },
						{
							opacity: 1,
							y: 0,
							duration: 0.5,
						},
						'-=1'
					);
				}
				if (heroPromo) {
					timeline.to(
						heroPromo,
						{
							scale: 1,
							opacity: 1,
							duration: 0.5,
						},
						'-=0.5'
					);
				}
			});

			mm.add('(prefers-reduced-motion: reduce)', () => {
				if (hero) {
					timeline.fromTo(
						hero,
						{ autoAlpha: 0 },
						{ autoAlpha: 1, duration: 0.5 }
					);
				}

				let split = new SplitText(slide, {
					type: 'chars, words',
				});
				if (split) {
					timeline.from(split.chars, {
						opacity: 0,
						stagger: {
							from: 'start',
							each: 0.01,
						},
					});
				}

				if (heroFade) {
					timeline.fromTo(
						heroFade,
						{ opacity: 0 },
						{
							opacity: 1,
							duration: 0.5,
						},
						'-=1'
					);
				}
				if (heroPromo) {
					timeline.to(
						heroPromo,
						{
							scale: 1,
							opacity: 1,
							duration: 0,
						},
						'-=0.5'
					);
				}
			});
		});
	}

	// ─── Below-fold GSAP setup ────────────────────────────────────────────────
	// All animations below target elements that are never visible on initial
	// load. Deferring their setup to requestIdleCallback prevents long tasks
	// on DOMContentLoaded and keeps the main thread free for painting and
	// user interaction. ScrollTrigger still fires lazily as normal — nothing
	// visible to the user is delayed.
	requestIdle(() => {

		/**
		 * Floating Cards
		 */
		const floatingCards = document.querySelectorAll('.floating-card-rotate');

		if (floatingCards.length) {
			gsap.utils
				.toArray('.floating-card-rotate')
				.forEach((card, index, cards) => {
					const rotation = card.getAttribute('data-rotation'); // Get rotation value from data-rotation

					let xPosition = 0;
					if (index === 0 || index === 3) {
						// Cards 1 and 4 move from right
						xPosition = '100%';
					} else if (index === 2 || index === 5) {
						// Cards 3 and 6 move from left
						xPosition = '-100%';
					}

					// Apply animation
					mm.add('(prefers-reduced-motion: no-preference)', () => {
						gsap.fromTo(
							card,
							{
								x: xPosition,
							},
							{
								x: 0,
								rotation: rotation,
								duration: 1.5,
								scrollTrigger: {
									trigger: card,
									start: 'top 80%',
								},
							}
						);
					});

					mm.add('(prefers-reduced-motion: reduce)', () => {
						gsap.set(card, { x: 0, rotation: rotation });
					});
				});
		}

		const svgTextContainer = document.querySelector('#svg-text');
		const textOnPath = document.querySelector('.text-on-path');

		if (svgTextContainer && textOnPath) {
			const originalText = textOnPath.innerHTML;
			textOnPath.innerHTML = originalText.repeat(5);

			const pathText = svgTextContainer.querySelector('#textOnPath2');

			if (pathText) {
				mm.add('(prefers-reduced-motion: no-preference)', () => {
					gsap.timeline({
						scrollTrigger: {
							scrub: 1.5,
							trigger: svgTextContainer,
							start: '0% 100%',
							end: '100% 10%',
						},
					}).to(pathText, {
						attr: { startOffset: '20%' },
					});
				});
			}
		}

		mm.add('(prefers-reduced-motion: no-preference)', () => {
			gsap.utils.toArray('.wave-floating-image').forEach((el, i) => {
				gsap.to(el, {
					y: i % 2 === 0 ? -25 : 25,
					duration: 2 + Math.random(), // shorter duration
					repeat: -1,
					yoyo: true,
					ease: 'power1.inOut',
					delay: Math.random() * 0.75, // quicker stagger
				});
			});
		});

		ScrollTrigger.refresh();

		/**
		 * Fade In on Scroll
		 */
		const fade = document.querySelectorAll('.fade');

		if (fade && fade.length > 0) {
			mm.add('(prefers-reduced-motion: no-preference)', () => {
				gsap.set('.fade', { y: 40, opacity: 0 });

				ScrollTrigger.batch('.fade', {
					start: 'top 80%',
					onEnter: (batch) =>
						gsap.to(batch, {
							opacity: 1,
							y: 0,
							stagger: {
								amount: '0.25',
							},
						}),
				});
			});

			mm.add('(prefers-reduced-motion: reduce)', () => {
				gsap.set('.fade', { opacity: 0 });

				ScrollTrigger.batch('.fade', {
					start: 'top 80%',
					onEnter: (batch) =>
						gsap.to(batch, {
							opacity: 1,
							stagger: {
								amount: '0.25',
							},
						}),
				});
			});
		}

		// Smooth parallax scroll for .plax-img (background)
		if (document.querySelectorAll('.plax').length > 0) {
			gsap.utils.toArray('.plax .plax-img').forEach((el) => {
				const distance = el.offsetHeight - el.parentElement.offsetHeight;
				mm.add('(prefers-reduced-motion: no-preference)', () => {
					gsap.fromTo(
						el,
						{ y: -distance },
						{
							y: -5,
							ease: 'power1.out',
							scrollTrigger: {
								trigger: el.parentElement,
								start: 'top bottom',
								end: 'bottom top',
								scrub: 0.6,
							},
						}
					);
				});
			});
		}

		// Only run ScrollTrigger animations on desktop
		(function () {
			// if (!window.matchMedia('(max-width: 767px)').matches) {
			const section = document.querySelector('.hero-center-reveal');
			if (!section) return;

			const leftItems = gsap.utils.toArray(
				section.querySelectorAll('.main-section--left .media-container > *')
			);
			const rightItems = gsap.utils.toArray(
				section.querySelectorAll(
					'.main-section--right .media-container > *'
				)
			);
			const leftBg = section.querySelector('.main-section--left .background');
			const rightBg = section.querySelector(
				'.main-section--right .background'
			);
			const overlay = section.querySelector('.main-section--video-overlay');
			const titleLines = section.querySelectorAll(
				'.split-main-title h3, .split-main-title div'
			);
			const pinSection = section.querySelector('.hero-center-reveal--main');
			if (!pinSection) return;

			const scrollLength = section.offsetHeight;
			const hasTargets = (el) => {
				if (!el) return false;
				if (typeof el.length === 'number' && el.length === 0) return false;
				return true;
			};

			mm.add(
				'(min-width: 768px) and (prefers-reduced-motion: no-preference)',
				() => {
					// 🟣 Animate backgrounds BEFORE the pinning starts (feels fluid)
					if (leftBg) {
						gsap.from(leftBg, {
							xPercent: -60,
							ease: 'power2.out',
							scrollTrigger: {
								trigger: section,
								start: 'top bottom', // starts when section enters viewport
								end: 'top top', // ends as pin begins
								scrub: 0.6,
							},
						});
					}

					if (rightBg) {
						gsap.from(rightBg, {
							xPercent: 60,
							ease: 'power2.out',
							scrollTrigger: {
								trigger: section,
								start: 'top bottom',
								end: 'top top',
								scrub: 0.6,
							},
						});
					}

					// 🟣 Main pinned timeline
					const tl = gsap.timeline({
						scrollTrigger: {
							trigger: pinSection,
							start: 'top top+=5%',
							end: `+=${scrollLength}`,
							scrub: 0.6,
							pin: true,
							pinSpacing: true,
							anticipatePin: 1,
							markers: false,
						},
					});

					// Optional overlay fade
					if (overlay) {
						tl.fromTo(
							overlay,
							{ opacity: 0 },
							{ opacity: 0.7, duration: 0.6 },
							0.6
						);
					}

					// Text reveal (or use SplitText if available)
					if (hasTargets(titleLines)) {
						tl.from(
							titleLines,
							{
								opacity: 0,
								yPercent: 100,
								stagger: 0.1,
								duration: 0.6,
								ease: 'power2.out',
							},
							0.8
						);
					}

					// Floating left images
					if (hasTargets(leftItems)) {
						tl.from(
							leftItems,
							{
								xPercent: () => gsap.utils.random(-90, -30),
								autoAlpha: 0,
								scale: 0.95,
								ease: 'power3.out',
								duration: 2,
								stagger: 0.25,
							},
							1.4
						);
					}

					// Floating right images
					if (hasTargets(rightItems)) {
						tl.from(
							rightItems,
							{
								xPercent: () => gsap.utils.random(30, 70),
								autoAlpha: 0,
								scale: 0.95,
								ease: 'power3.out',
								duration: 2,
								stagger: 0.25,
							},
							1.6
						);
					}
				}
			);

			mm.add(
				'(min-width: 768px) and (prefers-reduced-motion: reduce)',
				() => {
					const tl = gsap.timeline({
						scrollTrigger: {
							trigger: pinSection,
							start: 'top 80%',
						},
					});

					const targets = [
						overlay,
						leftBg,
						rightBg,
						titleLines,
						leftItems,
						rightItems,
					].filter(hasTargets);

					if (targets.length > 0) {
						tl.fromTo(
							targets,
							{ opacity: 0 },
							{ opacity: 1, duration: 1, stagger: 0.1 }
						);
					}
				}
			);
			// }
		})();

		/**
		 * Video Thumbnail Scale on Scroll
		 */
		const videoThumbnails = document.querySelectorAll(
			'.video-thumbnail-holder'
		);
		videoThumbnails.forEach((holder) => {
			const zoomElement = holder.querySelector('.video-thumbnail-zoom');

			if (zoomElement) {
				mm.add('(prefers-reduced-motion: no-preference)', () => {
					gsap.timeline({
						scrollTrigger: {
							trigger: holder,
							start: 'top 50%',
						},
					}).to(zoomElement, { scale: 1, duration: 1 });
				});
				mm.add('(prefers-reduced-motion: reduce)', () => {
					gsap.set(zoomElement, { scale: 1 });
				});
			}
		});

		/**
		 * Centered Text Animation
		 */

		const centeredContent = document.querySelectorAll('.centered-content');

		if (centeredContent.length > 0) {
			centeredContent.forEach((holder) => {
				const sparkleCenterContainer = holder.querySelector(
					'#sparkleCenterLottie'
				);
				const sparkleLeftContainer =
					holder.querySelector('#sparkleLeftLottie');
				const sparkleRightContainer = holder.querySelector(
					'#sparkleRightLottie'
				);

				// Timeline without ScrollTrigger inside it
				const centeredTl = gsap.timeline();

				// Load Lottie animations (prevent infinite event binding)
				function loadLottie(container, path, tl, animationCallback) {
					if (typeof lottie === 'undefined') return;
					if (container) {
						const anim = lottie.loadAnimation({
							container: container,
							renderer: 'svg',
							loop: false,
							autoplay: false,
							path: path,
						});

						anim.addEventListener(
							'DOMLoaded',
							() => {
								animationCallback(anim);
							},
							{ once: true }
						); // 🔥 Prevent multiple event bindings
					}
				}

				if (sparkleCenterContainer) {
					// Add Lottie animations to timeline
					loadLottie(
						sparkleCenterContainer,
						themeData.sparkle05,
						centeredTl,
						(anim) => {
							centeredTl.call(() => anim.goToAndPlay(0), null, '0');
						}
					);
				}
				if (sparkleLeftContainer) {
					loadLottie(
						sparkleLeftContainer,
						themeData.sparkle03,
						centeredTl,
						(anim) => {
							centeredTl.call(() => anim.goToAndPlay(0), null, '0');
							mm.add(
								'(prefers-reduced-motion: no-preference)',
								() => {
									centeredTl.from(
										sparkleLeftContainer,
										{ x: '500px', duration: 2.5 },
										'0'
									);
								}
							);
							mm.add('(prefers-reduced-motion: reduce)', () => {
								centeredTl.from(
									sparkleLeftContainer,
									{ opacity: 0, duration: 1 },
									'0'
								);
							});
						}
					);
				}

				if (sparkleRightContainer) {
					loadLottie(
						sparkleRightContainer,
						themeData.sparkle04,
						centeredTl,
						(anim) => {
							centeredTl.call(() => anim.goToAndPlay(0), null, '0');
							mm.add(
								'(prefers-reduced-motion: no-preference)',
								() => {
									centeredTl.from(
										sparkleRightContainer,
										{ x: '-500px', duration: 2.5 },
										'0'
									);
								}
							);
							mm.add('(prefers-reduced-motion: reduce)', () => {
								centeredTl.from(
									sparkleRightContainer,
									{ opacity: 0, duration: 1 },
									'0'
								);
							});
						}
					);
				}

				// SplitText Animation (only if element exists)
				const title = holder.querySelector('.centered-title');
				if (title) {
					let split = new SplitText(title, { type: 'chars, words' });
					const splitDelay = sparkleLeftContainer ? '+=2.5' : '0';

					mm.add('(prefers-reduced-motion: no-preference)', () => {
						centeredTl.from(
							split.chars,
							{
								opacity: 0,
								y: 50,
								stagger: { from: 'random', each: 0.02 },
							},
							splitDelay
						);
					});
					mm.add('(prefers-reduced-motion: reduce)', () => {
						centeredTl.from(
							split.chars,
							{
								opacity: 0,
								stagger: { from: 'random', each: 0.02 },
							},
							splitDelay
						);
					});
				}

				// Fade-in animation
				const centeredFade = holder.querySelector('.centered-fade');
				if (centeredFade) {
					mm.add('(prefers-reduced-motion: no-preference)', () => {
						centeredTl.fromTo(
							centeredFade,
							{ y: 40, opacity: 0 },
							{ opacity: 1, y: 0, duration: 0.5 },
							'-=0.5'
						);
					});
					mm.add('(prefers-reduced-motion: reduce)', () => {
						centeredTl.fromTo(
							centeredFade,
							{ opacity: 0 },
							{ opacity: 1, duration: 0.5 },
							'-=0.5'
						);
					});
				}

				// Attach ScrollTrigger outside the timeline
				ScrollTrigger.create({
					trigger: holder,
					start: 'top+=100% bottom',
					once: true,
					animation: centeredTl, // 🔥 Ensures timeline runs only once
				});
			});
		}

		/**
		 * Parallax Images
		 */
		const bgParallax = document.querySelectorAll('.bg-parallax');

		if (bgParallax.length > 0) {
			bgParallax.forEach((e, t) => {
				var n = e.offsetHeight - e.parentElement.offsetHeight;
				mm.add('(prefers-reduced-motion: no-preference)', () => {
					gsap.timeline().fromTo(
						e,
						{ y: -n },
						{
							scrollTrigger: { trigger: e.parentElement, scrub: !0 },
							y: -5,
							ease: 'none',
						}
					);
				});
			});
		}

		/**
		 * Large CTA Fade on Scroll
		 */
		const largeCTA = document.querySelectorAll('.large-cta');
		largeCTA.forEach((holder) => {
			const ctaContent = holder.querySelector('.cta-content');
			const ownerQuote = holder.querySelector('.owner-quote');
			if (ctaContent) {
				mm.add('(prefers-reduced-motion: no-preference)', () => {
					gsap.timeline({
						scrollTrigger: {
							trigger: holder,
							start: 'top 50%',
						},
					}).fromTo(
						ctaContent,
						{ opacity: 0, y: 40 },
						{ opacity: 1, y: 0, duration: 1 }
					);
				});
				mm.add('(prefers-reduced-motion: reduce)', () => {
					gsap.timeline({
						scrollTrigger: {
							trigger: holder,
							start: 'top 50%',
						},
					}).fromTo(
						ctaContent,
						{ opacity: 0 },
						{ opacity: 1, duration: 1 }
					);
				});
			}
			if (ownerQuote) {
				mm.add('(prefers-reduced-motion: no-preference)', () => {
					gsap.timeline({
						scrollTrigger: {
							trigger: holder,
							start: 'top 50%',
						},
					}).fromTo(
						ownerQuote,
						{ opacity: 0, y: 40 },
						{ opacity: 1, y: 0, duration: 1 }
					);
				});
				mm.add('(prefers-reduced-motion: reduce)', () => {
					gsap.timeline({
						scrollTrigger: {
							trigger: holder,
							start: 'top 50%',
						},
					}).fromTo(
						ownerQuote,
						{ opacity: 0 },
						{ opacity: 1, duration: 1 }
					);
				});
			}

			const bgParallaxLarge = document.querySelectorAll('.bg-parallax-large');

			if (bgParallaxLarge.length > 0) {
				bgParallaxLarge.forEach((e, t) => {
					var n = e.offsetHeight - e.parentElement.offsetHeight;
					mm.add('(prefers-reduced-motion: no-preference)', () => {
						gsap.timeline().fromTo(
							e,
							{ y: -n },
							{
								scrollTrigger: { trigger: '.large-cta', scrub: !0 },
								y: -5,
								ease: 'none',
							}
						);
					});
				});
			}
		});

		/**
		 * CTA Scale on Scroll
		 */
		const scaleContainer = document.querySelectorAll('.scale-container');
		if (scaleContainer.length > 0) {
			scaleContainer.forEach((element) => {
				mm.add('(prefers-reduced-motion: no-preference)', () => {
					gsap.timeline({
						scrollTrigger: {
							trigger: '.scale-container',
							start: 'top bottom',
						},
					}).to(element, { scale: 1, duration: 1, ease: 'none' });
				});
				mm.add('(prefers-reduced-motion: reduce)', () => {
					gsap.set(element, { scale: 1 });
				});
			});
		}
		const ctaBg = document.querySelectorAll('.bg-overlay-scale');
		if (ctaBg.length > 0) {
			ctaBg.forEach((element) => {
				mm.add('(prefers-reduced-motion: no-preference)', () => {
					gsap.timeline({
						scrollTrigger: {
							trigger: '.bg-overlay-scale',
							start: 'top bottom',
							end: 'bottom bottom',
							scrub: 1,
						},
					}).to(element, { scale: 1, duration: 1, ease: 'none' });
				});
			});
		}
		const blogVideo = document.querySelectorAll('.blog-video');
		if (blogVideo.length > 0) {
			blogVideo.forEach((element) => {
				gsap.timeline({
					scrollTrigger: {
						trigger: '.blog-video',
						start: 'top bottom',
						end: 'bottom bottom',
						scrub: 1,
					},
				}).to(element, { scale: 1, duration: 1, ease: 'none' });
			});
		}

		/**
		 * Schedule Filtering
		 */
		const buttons = document.querySelectorAll(
			'button.schedule-filter[data-type]'
		);

		if (buttons) {
			const dataDivs = document.querySelectorAll(
				'div.schedule-filter[data-type]'
			);

			buttons.forEach((button) => {
				button.addEventListener('click', function () {
					const type = button.getAttribute('data-type');
					const isActive = button.classList.contains('active');

					buttons.forEach((btn) => btn.classList.remove('active'));

					if (isActive) {
						dataDivs.forEach((div) =>
							div.classList.remove('opacity-25', 'opacity-100')
						);
					} else {
						button.classList.add('active');
						dataDivs.forEach((div) => {
							if (div.getAttribute('data-type') === type) {
								div.classList.add('opacity-100');
								div.classList.remove('opacity-25');
							} else {
								div.classList.add('opacity-25');
								div.classList.remove('opacity-100');
							}
						});
					}
				});
			});
		}

		const blogOutro = document.getElementById('blogOutroLottie');

		if (blogOutro && typeof lottie !== 'undefined') {
			const blogOutroLottie = lottie.loadAnimation({
				container: document.getElementById('blogOutroLottie'), // Ensure this exists in HTML
				renderer: 'svg',
				loop: false, // Set to true if you want it to repeat
				autoplay: false, // We'll control playback manually
				path: themeData.sparkle05, // Replace with actual Lottie JSON path
			});

			const blogOutro = gsap.timeline({
				scrollTrigger: {
					trigger: '#blogOutroLottie',
					start: 'top 50%',
					onEnter: () => {
						blogOutroLottie.goToAndPlay(0); // Play animation when triggered
					},
					onLeaveBack: () => {
						blogOutroLottie.goToAndPlay(0); // Play again when scrolling back
					},
				},
			});
		}

		const usMap = document.getElementById('usMapLottie');
		if (usMap && typeof lottie !== 'undefined') {
			const usMapLottie = lottie.loadAnimation({
				container: document.getElementById('usMapLottie'), // Ensure this exists in HTML
				renderer: 'svg',
				loop: true, // Set to true if you want it to repeat
				autoplay: false, // We'll control playback manually
				path: themeData.usMap, // Replace with actual Lottie JSON path
			});

			const usMap = gsap.timeline({
				scrollTrigger: {
					trigger: '#usMapLottie',
					start: 'top 50%',
					onEnter: () => {
						usMapLottie.goToAndPlay(0); // Play animation when triggered
					},
					onLeaveBack: () => {
						usMapLottie.goToAndPlay(0); // Play again when scrolling back
					},
				},
			});
		}

		const sliderLeft = document.getElementById('sliderLeftLottie');
		if (sliderLeft && typeof lottie !== 'undefined') {
			const sliderLeftLottie = lottie.loadAnimation({
				container: document.getElementById('sliderLeftLottie'), // Ensure this exists in HTML
				renderer: 'svg',
				loop: true, // Set to true if you want it to repeat
				autoplay: false, // We'll control playback manually
				path: themeData.sparkle03, // Replace with actual Lottie JSON path
			});

			const sliderLeft = gsap.timeline({
				scrollTrigger: {
					trigger: '#sliderLeftLottie',
					start: 'top 50%',
					onEnter: () => {
						sliderLeftLottie.goToAndPlay(0); // Play animation when triggered
					},
					onLeaveBack: () => {
						sliderLeftLottie.goToAndPlay(0); // Play again when scrolling back
					},
				},
			});
		}

		const sliderRight = document.getElementById('sliderRightLottie');
		if (sliderRight && typeof lottie !== 'undefined') {
			const sliderRightLottie = lottie.loadAnimation({
				container: document.getElementById('sliderRightLottie'), // Ensure this exists in HTML
				renderer: 'svg',
				loop: true, // Set to true if you want it to repeat
				autoplay: false, // We'll control playback manually
				path: themeData.sparkle03, // Replace with actual Lottie JSON path
			});

			const sliderRight = gsap.timeline({
				scrollTrigger: {
					trigger: '#sliderRightLottie',
					start: 'top 50%',
					onEnter: () => {
						sliderRightLottie.goToAndPlay(0); // Play animation when triggered
					},
					onLeaveBack: () => {
						sliderRightLottie.goToAndPlay(0); // Play again when scrolling back
					},
				},
			});
		}

		const usGlobalMap = document.getElementById('usGlobalMapLottie');
		if (usGlobalMap && typeof lottie !== 'undefined') {
			const usGlobalMapLottie = lottie.loadAnimation({
				container: document.getElementById('usGlobalMapLottie'), // Ensure this exists in HTML
				renderer: 'svg',
				loop: true, // Set to true if you want it to repeat
				autoplay: false, // We'll control playback manually
				path: themeData.usGlobalMap, // Replace with actual Lottie JSON path
			});

			const usGlobalMap = gsap.timeline({
				scrollTrigger: {
					trigger: '#usGlobalMapLottie',
					start: 'top 50%',
					onEnter: () => {
						usGlobalMapLottie.goToAndPlay(0); // Play animation when triggered
					},
					onLeaveBack: () => {
						usGlobalMapLottie.goToAndPlay(0); // Play again when scrolling back
					},
				},
			});
		}

		const weMakeMagic = document.getElementById('weMakeMagicLottie');
		if (weMakeMagic && typeof lottie !== 'undefined') {
			const weMakeMagicLottie = lottie.loadAnimation({
				container: document.getElementById('weMakeMagicLottie'),
				renderer: 'svg',
				loop: false,
				autoplay: false,
				path: typeof themeData !== 'undefined' ? themeData.weMakeMagic : '',
			});

			if ('IntersectionObserver' in window) {
				const magicObserver = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							if (entry.isIntersecting) {
								weMakeMagicLottie.goToAndPlay(0);
							} else if (entry.boundingClientRect.top > 0) {
								weMakeMagicLottie.goToAndStop(0, true);
							}
						});
					},
					{
						root: null,
						rootMargin: '0px 0px -30% 0px',
						threshold: 0,
					}
				);
				magicObserver.observe(weMakeMagic);
			} else {
				const weMakeMagicTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: '#weMakeMagicLottie',
						start: 'top 70%',
						onEnter: () => {
							weMakeMagicLottie.goToAndPlay(0);
						},
						onLeaveBack: () => {
							weMakeMagicLottie.goToAndStop(0, true);
						},
					},
				});
			}
		}

		// Function to initialize Lottie animations
		const initLottieAnimation = (lottieId, hoverElement, lottiePath, num) => {
			if (typeof lottie === 'undefined') return;
			const animationContainer = document.getElementById(lottieId);
			const hoverTarget = document.querySelector(hoverElement);

			if (animationContainer && hoverTarget) {
				const animation = lottie.loadAnimation({
					container: animationContainer,
					renderer: 'svg',
					loop: false,
					autoplay: false,
					path: lottiePath, // Replace with your Lottie JSON file path
				});

				// Set initial frame to 70% of the animation
				animation.addEventListener('DOMLoaded', () => {
					animation.goToAndStop(animation.totalFrames * num, true);
				});

				// Play on hover and loop
				hoverTarget.addEventListener('mouseenter', () => {
					animation.loop = true;
					animation.play();
				});

				// Play until it reaches 70% on mouseleave
				hoverTarget.addEventListener('mouseleave', () => {
					const targetFrame = animation.totalFrames * num;

					const checkFrame = () => {
						if (animation.currentFrame >= targetFrame) {
							animation.pause();
						} else {
							requestAnimationFrame(checkFrame);
						}
					};

					animation.loop = false;
					animation.play();
					checkFrame();
				});
			}
		};

		// Initialize animations for multiple instances
		initLottieAnimation(
			'sparklePinkLottie',
			'.registration-card-pink',
			themeData.sparkle02Pink,
			0.73
		);

		initLottieAnimation(
			'sparklePeriwinkleLottie',
			'.registration-card-periwinkle',
			themeData.sparkle03Periwinkle,
			0.8
		);

		initLottieAnimation(
			'singleStar01',
			'.single-star',
			themeData.singleStar,
			0.8
		);

		initLottieAnimation(
			'singleStar02',
			'.single-star',
			themeData.singleStar,
			0.8
		);

		initLottieAnimation(
			'singleStar03',
			'.single-star',
			themeData.singleStar,
			0.8
		);

		initLottieAnimation(
			'singleStar04',
			'.single-star',
			themeData.singleStar,
			0.8
		);

		initLottieAnimation(
			'sparklePurpleLottie',
			'.testimonial-slider',
			themeData.sparkle01,
			0.8
		);

		initLottieAnimation(
			'sparklePurpleLottie',
			'#trigger-location-search',
			themeData.sparkle01,
			0.8
		);

		initLottieAnimation(
			'sparkleYellowLottie',
			'#trigger-location-directory',
			themeData.sparkle01Yellow,
			0.8
		);

		const benefitImages = gsap.utils.toArray(
			'.benefits-image-group .image-block'
		);

		if (benefitImages.length) {
			const directions = [
				{ x: -80, y: -40, rotate: -8 },
				{ x: 80, y: -30, rotate: 8 },
				{ x: -60, y: 40, rotate: -6 },
				{ x: 60, y: 60, rotate: 6 },
			];

			benefitImages.forEach((img, i) => {
				const d = directions[i % directions.length];

				mm.add('(prefers-reduced-motion: no-preference)', () => {
					gsap.fromTo(
						img,
						{
							x: d.x,
							y: d.y,
							rotate: d.rotate,
							opacity: 0,
						},
						{
							scrollTrigger: {
								trigger: '.benefits-image-group',
								start: 'top 100%',
								scrub: 1.2, // Smooth scrubbing
							},
							x: 0,
							y: 0,
							rotate: 0,
							opacity: 1,
							ease: 'power2.out',
						}
					);
				});

				mm.add('(prefers-reduced-motion: reduce)', () => {
					gsap.fromTo(
						img,
						{ opacity: 0 },
						{
							scrollTrigger: {
								trigger: '.benefits-image-group',
								start: 'top 80%',
							},
							opacity: 1,
							duration: 1,
						}
					);
				});
			});
		}

		// Recalculate all ScrollTrigger positions after deferred setup completes.
		ScrollTrigger.refresh();

	}); // end requestIdle
});

/**
 * Question Form Popup
 */
const btn = document.querySelector('.btn-signup');

if (btn) {
	btn.addEventListener('click', function () {
		const holder = document.querySelector('.btn-signup-holder');
		if (holder) {
			holder.classList.toggle('active');
		}
	});
}

// Load Lottie animation
const questionContainer = document.getElementById('questionContainer');
let questionLottie = null;

if (questionContainer && typeof lottie !== 'undefined') {
	questionLottie = lottie.loadAnimation({
		container: questionContainer,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: themeData.sparkle03Purple, // Replace with your Lottie JSON file path
	});
}

let hasAnimated = false;

function triggerAnimation() {
	if (hasAnimated) return;
	hasAnimated = true;

	const signupHolder = document.querySelector('.btn-signup-holder');
	if (signupHolder) {
		gsap.fromTo(
			signupHolder,
			{ scale: 0 },
			{ scale: 1, duration: 1, ease: 'circ.out' }
		);
	}

	if (questionLottie) {
		const targetFrame = questionLottie.totalFrames * 0.77;
		let attempts = 0;
		const maxAttempts = 100;

		const checkFrame = () => {
			if (
				questionLottie.currentFrame >= targetFrame ||
				attempts > maxAttempts
			) {
				questionLottie.pause();
			} else {
				attempts++;
				setTimeout(checkFrame, 33); // ~30fps
			}
		};

		questionLottie.play();
		checkFrame();
	}
}

function checkScrollPosition() {
	if (hasAnimated) return;

	const scrollY = window.scrollY || window.pageYOffset;
	const triggerPoint = document.documentElement.scrollHeight / 2;

	if (scrollY + window.innerHeight >= triggerPoint) {
		triggerAnimation();
		window.removeEventListener('scroll', checkScrollPosition);
	}
}

// Check on load in case user is already past halfway
window.addEventListener('load', () => {
	checkScrollPosition(); // reuses the same logic
});

// Also listen to scroll
window.addEventListener('scroll', checkScrollPosition, { passive: true });

function changeStep(oldStep, newStep, isReverse = false) {
	const registrationTop = document.getElementById('registration-top');
	if (registrationTop) {
		registrationTop.scrollIntoView();
	}
	const registrationType = getRegistrationType();

	gsap.to(':root', {
		ease: 'circ.out',
		duration: '0.5',
		'--bgReg':
			registrationType === 'CAMP'
				? '#f3eeff'
				: registrationType === 'PARTY'
					? '#f9eeee'
					: registrationType === 'BB'
						? '#f8f3dd'
						: '#f3e8fa',
		immediateRender: false,
	});

	const oldNavItem = document.querySelector(
		`.registration-progress li[data-id="${oldStep}"]`
	);
	const newNavItem = document.querySelector(
		`.registration-progress li[data-id="${newStep}"]`
	);
	const oldContent = document.getElementById(oldStep);
	const newContent = document.getElementById(newStep);
	const navChange = gsap.timeline();

	if (oldNavItem) {
		navChange.to(oldNavItem.querySelector('h3'), {
			fontSize: '16px',
			lineHeight: '24px',
			color: isReverse ? '#5A6778' : '#CE768C',
			duration: 0.3,
		});
		navChange.to(oldNavItem.querySelector('.registration-info'), {
			backgroundColor: isReverse ? 'transparent' : '#f9eeee',
			duration: 0.3,
		});
		navChange.to(oldNavItem.querySelector('.p-holder'), {
			opacity: 0,
			height: 0,
			duration: 0.3,
		});
		navChange.to(oldNavItem.querySelector('h3'), {
			x: isReverse ? '-42px' : 0,
			duration: 0.3,
		});
		navChange.to(oldNavItem.querySelector('svg'), {
			opacity: isReverse ? 0 : 1,
			duration: 0.5,
		});
		if (isReverse) {
			navChange.to(oldNavItem, { opacity: 0.5, duration: 0.3 }, 0);
		}
	}

	if (newNavItem) {
		navChange.addLabel('new', '-=0.3');
		navChange.to(newNavItem, { opacity: 1, duration: 0.3 }, 'new');
		navChange.to(
			newNavItem.querySelector('h3'),
			{
				x: '-27px',
				fontSize: '21px',
				lineHeight: '31px',
				duration: 0.3,
			},
			'new'
		);
		navChange.to(
			newNavItem.querySelector('.registration-info'),
			{
				backgroundColor: '#FCD0D9',
				duration: 0.3,
			},
			'new'
		);
		navChange.to(
			newNavItem.querySelector('.p-holder'),
			{ height: 'auto' },
			'new'
		);
		navChange.to(
			newNavItem.querySelector('.p-holder'),
			{ opacity: 1 },
			'new+=0.3'
		);
		if (isReverse) {
			navChange.to(
				newNavItem.querySelector('svg'),
				{ opacity: 0, duration: 0.3 },
				0
			);
		}
	}

	if (oldContent && newContent) {
		gsap.to(oldContent, {
			duration: 0.5,
			opacity: 0,
			scale: 0.95,
			ease: 'circ.out',
			onComplete: () => {
				oldContent.style.display = 'none';
				newContent.style.display = 'block';

				gsap.fromTo(
					newContent,
					{ opacity: 0, scale: 1.05 },
					{ opacity: 1, scale: 1, duration: 0.5, ease: 'circ.out' }
				);
				if (newStep === 'thank-you') {
					playConfettiAnimation();
				}
			},
		});
	}
}

function setRegistrationType(type) {
	localStorage.setItem('registrationType', type);
}

function resetRegistrationType() {
	localStorage.removeItem('registrationType');
}

function getRegistrationType() {
	const storedType = localStorage.getItem('registrationType');
	return storedType || null;
}

function setRegistrationPrice(price) {
	localStorage.setItem('registrationPrice', price);
}

function getRegistrationPrice() {
	const storedPrice = localStorage.getItem('registrationPrice');
	return storedPrice || null;
}

function getCurrency() {
	const currency = document.getElementById('currency').value;
	return currency || '$';
}

function getCurrencyPostfix() {
	const business_id = document.getElementById('business_id')?.value.trim();

	return business_id === '7433' ? '+gst' : '';
}

localStorage.setItem('requirePayment', '1');
localStorage.setItem('waitlist', false);

function checkPayment(type, price) {
	const registrationType = getRegistrationType();
	const registrationPrice = getRegistrationPrice();
	const cc_required_for_trial = document.getElementById(
		'cc_required_for_trial'
	).value;
	const cc_required_for_waitlist = document.getElementById(
		'cc_required_for_waitlist'
	).value;
	let requirePayment = '0';
	if (cc_required_for_trial === '0' && type === 'trial') {
		document
			.querySelectorAll('.show-payment')
			.forEach((btn) => btn.classList.add('active'));
		document
			.querySelectorAll('.hide-payment')
			.forEach((btn) => btn.classList.add('active'));
	} else if (cc_required_for_waitlist === '0' && type === 'wait') {
		document
			.querySelectorAll('.show-payment')
			.forEach((btn) => btn.classList.add('active'));
		document
			.querySelectorAll('.hide-payment')
			.forEach((btn) => btn.classList.add('active'));
	} else if (type === 'wait' && registrationType === 'EVENT' && price === 0) {
		document
			.querySelectorAll('.show-payment')
			.forEach((btn) => btn.classList.add('active'));
		document
			.querySelectorAll('.hide-payment')
			.forEach((btn) => btn.classList.add('active'));
	} else if (
		(type === 'event' || registrationType === 'EVENT') &&
		(price === 0 || price === '0')
	) {
		document
			.querySelectorAll('.show-payment')
			.forEach((btn) => btn.classList.add('active'));
		document
			.querySelectorAll('.hide-payment')
			.forEach((btn) => btn.classList.add('active'));
	} else {
		document
			.querySelectorAll('.show-payment')
			.forEach((btn) => btn.classList.remove('active'));
		document
			.querySelectorAll('.hide-payment')
			.forEach((btn) => btn.classList.remove('active'));
		requirePayment = '1';
	}
	localStorage.setItem('requirePayment', requirePayment);
}

function setWaitlist(boolean) {
	const registrationPrice = getRegistrationPrice();
	const registrationType = getRegistrationType();

	if (boolean === 'true') {
		document
			.querySelectorAll('.show-wait')
			.forEach((btn) => btn.classList.add('active'));
		document
			.querySelectorAll('.hide-wait')
			.forEach((btn) => btn.classList.add('active'));
		checkPayment('wait', '');
	} else {
		document
			.querySelectorAll('.show-wait')
			.forEach((btn) => btn.classList.remove('active'));
		document
			.querySelectorAll('.hide-wait')
			.forEach((btn) => btn.classList.remove('active'));
		checkPayment(
			registrationType === 'EVENT' ? 'event' : '',
			registrationPrice
		);
	}
	localStorage.setItem('waitlist', boolean);
}

function resetWaillist() {
	localStorage.removeItem('waitlist');
}

function getWaitlist() {
	const storedWaitlist = localStorage.getItem('waitlist');
	return storedWaitlist || false;
}

function showTrial(registrationType) {
	const acceptMonthly = document.getElementById('accept_monthly');

	if (registrationType === 'TRIAL') {
		document
			.querySelectorAll('.show-trial')
			.forEach((btn) => btn.classList.add('active'));
		document
			.querySelectorAll('.hide-trial')
			.forEach((btn) => btn.classList.add('active'));
		if (acceptMonthly) {
			acceptMonthly.checked = true;
		}
		checkPayment('trial', '');
	} else if (registrationType !== 'EVENT') {
		document
			.querySelectorAll('.show-trial')
			.forEach((btn) => btn.classList.remove('active'));
		document
			.querySelectorAll('.hide-trial')
			.forEach((btn) => btn.classList.remove('active'));
		if (acceptMonthly) {
			acceptMonthly.checked = false;
		}
		checkPayment('', '');
	}
}

// Example usage when clicking a button
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.next-step-btn').forEach((button) => {
		button.addEventListener('click', () => {
			const oldStep = button.getAttribute('data-old-step');
			const newStep = button.getAttribute('data-new-step');
			const originalText = button.textContent; // Store original text

			button.textContent = 'Loading...'; // Show loading state
			button.disabled = true; // Prevent multiple clicks

			if (newStep === 'registration') {
				resetRegistrationType(); // clear old value
				const registrationType = button.getAttribute('data-type');
				setRegistrationType(registrationType); // store new one
				showTrial(registrationType);

				dataLayer.push({
					event: 'registrationTypeSelected',
					registrationType: registrationType,
				});
			}

			stepAction(newStep)
				.then(() => {
					changeStep(oldStep, newStep);
					button.textContent = originalText; // Restore original text on error
				})
				.catch((error) => {
					const exception = error?.exception || '';
					const message = error?.message || 'Something went wrong.';
					alert(exception + ' ' + message);
					console.error('Error in stepAction:', error);
					button.textContent = originalText; // Restore original text on error
				})
				.finally(() => {
					button.disabled = false; // Re-enable button after action completes
				});
		});
	});

	document.querySelectorAll('.prev-step-btn').forEach((button) => {
		button.addEventListener('click', () => {
			const oldStep = button.getAttribute('data-old-step');
			const newStep = button.getAttribute('data-new-step');
			changeStep(oldStep, newStep, true); // Pass true to indicate reverse transition
		});
	});

	document
		.querySelectorAll('#gift-card-information input')
		.forEach((input) => {
			input.addEventListener('input', () => {
				const errorEl = document.getElementById('gift-card-error');
				if (errorEl) {
					errorEl.classList.add('hidden');
					errorEl.textContent = '';
				}
			});
		});
});

let paymentSelect = false;

/*
================================================================================
Gift Card API Workflow
================================================================================
*/
let giftCardState = {
	cart_user_id: null,
	purchaser_email: '',
	purchaser_first_name: '',
	purchaser_last_name: '',
	amount: 0,
	outside_recipient: false,
	recipient_email: '',
	recipient_name: '',
	payment_method_token: null,
	card_description: '',
};

function isGiftCardFlow() {
	return !!document.getElementById('gift-card-information');
}

function validateGiftCardInformation() {
	const errorEl = document.getElementById('gift-card-error');
	if (errorEl) {
		errorEl.classList.add('hidden');
		errorEl.textContent = '';
	}

	const nameEl =
		document.getElementById('sender_name') ||
		document.getElementById('purchaser_name') ||
		document.getElementById('first_name');
	const emailEl = document.getElementById('sender_email');
	const amountEl = document.getElementById('amount');
	const outsideEl = document.getElementById('send_to_someone_else');
	const recNameEl = document.getElementById('recipient_name');
	const recEmailEl = document.getElementById('recipient_email');

	const name = nameEl?.value.trim() || '';
	const email = emailEl?.value.trim() || '';
	const amountVal = amountEl?.value.trim() || '';
	const isOutside = outsideEl ? outsideEl.checked : false;
	const recName = recNameEl?.value.trim() || '';
	const recEmail = recEmailEl?.value.trim() || '';

	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	function showError(msg, inputEl) {
		if (errorEl) {
			errorEl.textContent = msg;
			errorEl.classList.remove('hidden');
		}
		if (inputEl) {
			inputEl.focus();
		}
		throw new Error(msg);
	}

	if (!name) {
		showError('Please enter your name.', nameEl);
	}

	const nameParts = name.split(/\s+/);
	const firstName = nameParts[0] || '';
	const lastName = nameParts.slice(1).join(' ') || firstName;

	if (!email) {
		showError('Please enter your email address.', emailEl);
	}
	if (!emailRegex.test(email)) {
		showError('Please enter a valid email address.', emailEl);
	}

	const cleanedAmount = amountVal.replace(/[$,]/g, '').trim();
	const amount = Math.round(parseFloat(cleanedAmount));
	if (!cleanedAmount || isNaN(amount) || amount <= 0) {
		showError('Please enter a valid gift card amount in dollars.', amountEl);
	}

	if (isOutside) {
		if (!recName) {
			showError('Please enter the recipient’s name.', recNameEl);
		}
		if (!recEmail) {
			showError('Please enter the recipient’s email address.', recEmailEl);
		}
		if (!emailRegex.test(recEmail)) {
			showError('Please enter a valid email address for the recipient.', recEmailEl);
		}
	}

	return {
		purchaser_email: email,
		purchaser_first_name: firstName,
		purchaser_last_name: lastName,
		amount: amount,
		outside_recipient: isOutside,
		recipient_email: isOutside ? recEmail : '',
		recipient_name: isOutside ? recName : '',
	};
}

async function initiateGiftCardPurchase() {
	const validatedData = validateGiftCardInformation();
	const businessId =
		document.getElementById('business_id')?.value.trim() || 1;

	const params = {
		purchaser_email: validatedData.purchaser_email,
		purchaser_first_name: validatedData.purchaser_first_name,
		purchaser_last_name: validatedData.purchaser_last_name,
		amount: validatedData.amount,
		outside_recipient: validatedData.outside_recipient,
	};

	if (validatedData.outside_recipient) {
		params.recipient_email = validatedData.recipient_email;
		params.recipient_name = validatedData.recipient_name;
	}

	try {
		const response = await fetchClassBugData(
			businessId,
			'gift_card/initiate',
			params,
			'POST'
		);

		if (response?.error) {
			throw new Error(response.error);
		}
		if (!response?.cart_user_id) {
			throw new Error(
				response?.message || 'Could not initiate gift card purchase.'
			);
		}

		giftCardState = {
			...validatedData,
			cart_user_id: response.cart_user_id,
			payment_method_token: giftCardState.payment_method_token || null,
			card_description: giftCardState.card_description || '',
		};

		try {
			sessionStorage.setItem(
				'tutu_gift_card_state',
				JSON.stringify(giftCardState)
			);
		} catch (e) { }

		const priceInput = document.getElementById('price');
		if (priceInput) {
			priceInput.value = validatedData.amount.toFixed(2);
		}

		renderGiftCardPaymentOptions();

		return response;
	} catch (err) {
		const errorEl = document.getElementById('gift-card-error');
		const msg =
			err?.message || 'Failed to initiate purchase. Please try again.';
		if (errorEl) {
			errorEl.textContent = msg;
			errorEl.classList.remove('hidden');
		}
		throw err;
	}
}

function renderGiftCardPaymentOptions() {
	const paymentOptions = document.getElementById('paymentOptions');
	const completeBtn = document.getElementById('complete-registration');
	if (!paymentOptions) return;

	if (giftCardState.payment_method_token) {
		paymentOptions.innerHTML = `
			<button 
			  data-token="${giftCardState.payment_method_token}"
			  class="btn btn-purple payment-card no-icon relative active">
			  <svg xmlns="http://www.w3.org/2000/svg" class="w-[30px] absolute left-4 transition-all"
				   viewBox="0 0 640 640">
				<path d="M320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576zM438 209.7C427.3 201.9 412.3 204.3 404.5 215L285.1 379.2L233 327.1C223.6 317.7 208.4 317.7 199.1 327.1C189.8 336.5 189.7 351.7 199.1 361L271.1 433C276.1 438 282.9 440.5 289.9 440C296.9 439.5 303.3 435.9 307.4 430.2L443.3 243.2C451.1 232.5 448.7 217.5 438 209.7z" />
			  </svg>
			  ${giftCardState.card_description || 'Card on File'}
			</button>`;
		if (completeBtn) {
			completeBtn.disabled = false;
		}
	} else {
		paymentOptions.innerHTML = `<p class="eyebrow">Please click "Add New Card" to enter your payment details</p>`;
		if (completeBtn) {
			completeBtn.disabled = true;
		}
	}
}

async function submitGiftCardPurchase() {
	try {
		const errorContainer = document.getElementById('error-message');
		if (errorContainer) {
			errorContainer.innerHTML = '';
		}

		if (!giftCardState.cart_user_id) {
			try {
				const stored = sessionStorage.getItem('tutu_gift_card_state');
				if (stored) {
					giftCardState = { ...giftCardState, ...JSON.parse(stored) };
				}
			} catch (e) { }
		}

		if (!giftCardState.cart_user_id) {
			throw new Error(
				'Your gift card session has expired. Please go back and try again.'
			);
		}

		const activeCard = document.querySelector(
			'#paymentOptions .payment-card.active:not([data-token="gift-card"])'
		);
		const paymentToken =
			activeCard?.getAttribute('data-token') ||
			giftCardState.payment_method_token;

		if (!paymentToken) {
			throw new Error(
				'Please add or select a card to complete your gift card purchase.'
			);
		}

		const businessId =
			document.getElementById('business_id')?.value.trim() || 1;

		const params = {
			cart_user_id: giftCardState.cart_user_id,
			payment_method_token: paymentToken,
			amount: giftCardState.amount,
			purchaser_email: giftCardState.purchaser_email,
			purchaser_first_name: giftCardState.purchaser_first_name,
			purchaser_last_name: giftCardState.purchaser_last_name,
			outside_recipient: giftCardState.outside_recipient,
		};

		if (giftCardState.outside_recipient) {
			params.recipient_email = giftCardState.recipient_email;
			params.recipient_name = giftCardState.recipient_name;
		}

		const purchaseResponse = await fetchClassBugData(
			businessId,
			'gift_card/purchase',
			params,
			'POST'
		);

		if (purchaseResponse?.error) {
			throw new Error(purchaseResponse.error);
		}

		const statusId = purchaseResponse?.checkout_job_status_id;
		if (!statusId) {
			throw new Error(
				purchaseResponse?.message ||
				'Failed to submit gift card purchase.'
			);
		}

		const finalStatus = await waitForRegistrationCompletion(
			statusId,
			2000,
			60000,
			'POST'
		);

		if (finalStatus?.checkout_status === 'complete') {
			const classTitleEl = document.querySelector('#thank-you .class-title');
			const classTimeEl = document.querySelector('#thank-you .class-time');

			if (classTitleEl) {
				classTitleEl.textContent = `$${giftCardState.amount} Gift Card`;
			}
			if (classTimeEl) {
				if (giftCardState.outside_recipient) {
					const rec = giftCardState.recipient_name
						? `${giftCardState.recipient_name} (${giftCardState.recipient_email})`
						: giftCardState.recipient_email;
					classTimeEl.textContent = `Recipient: ${rec}`;
				} else {
					const purchaser =
						`${giftCardState.purchaser_first_name} ${giftCardState.purchaser_last_name}`.trim();
					classTimeEl.textContent = `Recipient: ${purchaser} (${giftCardState.purchaser_email})`;
				}
			}

			try {
				sessionStorage.removeItem('tutu_gift_card_state');
			} catch (e) { }

			return finalStatus;
		} else {
			throw new Error(
				finalStatus?.message ||
				'Gift card purchase could not be completed.'
			);
		}
	} catch (err) {
		console.error('Gift card purchase error:', err);
		showErrorScreen(err);
		throw err;
	}
}

async function stepAction(newStep) {
	if (isGiftCardFlow()) {
		if (newStep === 'payment-information') {
			return initiateGiftCardPurchase();
		}
		if (newStep === 'add-card') {
			return updatePaymentMethodRequest();
		}
		if (newStep === 'thank-you') {
			return submitGiftCardPurchase();
		}
		return Promise.resolve();
	}

	const registrationType = getRegistrationType();

	if (newStep === 'registration') {
		return handleRegistrationStep();
	}
	if (newStep === 'student') {
		return handleStudentStep();
	}
	if (newStep === 'save-student') {
		return handleSaveStudentStep();
	}
	if (newStep === 'bravo-bash-student') {
		return handleBravoBashStudentStep();
	}
	if (newStep === 'class-selection') {
		return handleClassSelectionStep('class');
	}
	if (newStep === 'parties-selection') {
		return handleClassSelectionStep('party');
	}
	if (newStep === 'bravo-bash-selection') {
		return handleBravoBashSelectionStep();
	}
	if (newStep === 'terms-of-service') {
		if (registrationType !== 'BB') {
			return handleContactInformationStep();
		}
	}
	if (newStep === 'payment-information') {
		return handlePaymentInformation();
	}
	if (newStep === 'add-card') {
		return updatePaymentMethodRequest();
	}
	if (newStep === 'thank-you') {
		return submitRegistration();
	}
	return Promise.resolve(); // If no API call is needed
}

function handleRegistrationStep() {
	let url = new URL(window.location.href);
	let searchParams = new URLSearchParams(url.search);
	searchParams.set('action', 'loginRequest');
	url.search = searchParams.toString();
	window.history.pushState({ path: url.href }, '', url.href);

	window.ClassbugAPI.LoginRequest({ selector: '#classbug_login' })
		.then(function (response) {
			let url = new URL(window.location.href);
			let searchParams = new URLSearchParams(url.search);
			searchParams.delete('action');
			url.search = searchParams.toString();
			window.history.pushState({ path: url.href }, '', url.href);

			const token = response.ClassbugSessionToken();
			fetch('/wp-admin/admin-ajax.php', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams({
					action: 'store_classbug_token',
					token,
				}),
			})
				.then((response2) => response2.json())
				.then((data2) => {
					document
						.querySelectorAll('.logout-button.hidden')
						.forEach((el) => el.classList.remove('hidden'));

					const registrationType = getRegistrationType();

					const newStep =
						registrationType === 'BB'
							? 'bravo-bash-student'
							: 'student';
					stepAction(newStep)
						.then(() => {
							changeStep('registration', newStep);
						})
						.catch((error) => {
							alert(error);
							console.error('Error in stepAction:', error);
						});
				})
				.catch((error) => console.error('Fetch error:', error));
		})
		.catch(function (error) {
			$('#parent').append($('<h1>Failure</h1>'));
			$('#result').html($('<pre id="result"></pre>').html(error));
		});
}

function updatePaymentMethodRequest() {
	let url = new URL(window.location.href);
	let searchParams = new URLSearchParams(url.search);
	searchParams.set('action', 'updatePaymentMethodRequest');
	url.search = searchParams.toString();
	window.history.pushState({ path: url.href }, '', url.href);
	setTimeout(() => {
		window.ClassbugAPI.UpdatePaymentMethodRequest({
			selector: '#classbug_payment_method_request',
		})
			.then(function (response) {
				paymentSelect = true;
				if (isGiftCardFlow()) {
					const token =
						typeof response.PaymentMethodToken === 'function'
							? response.PaymentMethodToken()
							: response?.data?.object?.payment_method_token ||
							response?.payment_method_token;
					const desc =
						typeof response.Description === 'function'
							? response.Description()
							: response?.data?.object?.description ||
							'Credit Card';

					giftCardState.payment_method_token = token;
					giftCardState.card_description = desc;
					try {
						sessionStorage.setItem(
							'tutu_gift_card_state',
							JSON.stringify(giftCardState)
						);
					} catch (e) { }

					renderGiftCardPaymentOptions();
					changeStep('add-card', 'payment-information');
				} else {
					stepAction('payment-information')
						.then(() => {
							changeStep('add-card', 'payment-information');
						})
						.catch((error) => {
							alert(error);
							console.error('Error in stepAction:', error);
						});
				}
			})
			.catch(function (error) {
				$('#parent').append($('<h1>Failure</h1>'));
				$('#parent').html($('<pre id="error"></pre>').html(error));
			});
	}, 2000);
}

window.cb_defer = window.cb_defer || [];
window.cb_defer.push(function () {
	params = new URLSearchParams(window.location.search);
	if (params.get('action') === 'loginRequest') {
		handleRegistrationStep();
		const registrationType = getRegistrationType();

		gsap.to(':root', {
			ease: 'circ.out',
			duration: '0.5',
			'--bgReg':
				registrationType === 'CAMP'
					? '#f3eeff'
					: registrationType === 'PARTY'
						? '#f9eeee'
						: registrationType === 'BB'
							? '#f8f3dd'
							: '#f3e8fa',
			immediateRender: false,
		});
		document.getElementById('registration').scrollIntoView();
	}
	if (params.get('action') == 'updatePaymentMethodRequest') {
		updatePaymentMethodRequest();
		document.getElementById('registration').scrollIntoView();
	}
});

function formatPhoneNumber(phone) {
	// Remove all non-digit characters
	const cleaned = phone.replace(/\D/g, '');

	if (phone.includes('.')) {
		return phone;
	}

	// Only format if it's exactly 10 digits
	if (cleaned.length !== 10) {
		return phone; // return original if not 10 digits
	}

	// Format the number
	const formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
	return formatted;
}

// Handles fetching and displaying students
async function handleStudentStep() {
	try {
		const data = await fetchClassBugData(1, 'get_students', '', 'GET');
		if (data?.length) {
			const registrationType = getRegistrationType();

			const currentStudentsEl =
				document.getElementById('currentStudents');

			if (currentStudentsEl) {
				currentStudentsEl.innerHTML = data
					.map(
						(item) =>
							`<button data-id="${item.id}"
						data-address="${item.address}"
						data-cell-phone="${formatPhoneNumber(item.cell_phone)}"
						data-city="${item.city}"
						data-ec-name="${item.ec_name}"
						data-ec-phone="${formatPhoneNumber(item.ec_phone)}"
						data-home-phone="${formatPhoneNumber(item.home_phone)}"
						data-referral="${item.referral}"
						data-referral-comment="${item.referral_comment}"
						data-special-conditions="${item.special_conditions}"
						data-state="${item.state}"
						data-zip="${item.zip}"
						${item.trial_completed === true && registrationType === 'TRIAL' ? 'disabled' : ''}
						class="btn btn-purple current-student">${item.name} ${item.trial_completed === true && registrationType === 'TRIAL' ? ' | Trial Completed' : ''}</button>`
					)
					.join('');
			}
		}
	} catch (error) {
		console.error('API Error:', error);
		throw error;
	}
}

async function handleBravoBashStudentStep() {
	try {
		const data = await fetchClassBugData(1, 'get_bb_students', '', 'GET');
		if (data?.length) {
			const currentStudentsEl =
				document.getElementById('currentStudents');

			if (currentStudentsEl) {
				currentStudentsEl.innerHTML = data
					.map((item) => {
						if (!item.registered_for_bb) {
							return `<button
							data-id="${item.student_id}"
							class="btn btn-purple current-student">
					  ${item.student_name} | ${item.class_name} | ${item.class_details}
					</button>`;
						} else {
							return `<button
							disabled
							class="btn btn-purple">
					  ${item.student_name} | ${item.class_name} | ${item.class_details} | Already Registered
					</button>`;
						}
						return ''; // return empty string for filtered out items
					})
					.join('');
			}
		}
	} catch (error) {
		console.error('API Error:', error);
		throw error;
	}
}

let studentId = null;

async function handleSaveStudentStep(type) {
	studentId = await createStudent();
	if (!studentId) throw new Error('No Student ID');

	stepAction('student')
		.then(() => {
			changeStep('add-student', 'student');
		})
		.catch((error) => {
			alert(error);
			console.error('Error in stepAction:', error);
		});
}

// Handles class selection logic
async function handleClassSelectionStep(type) {
	const activeStudent = document.querySelector('.current-student.active');
	studentId = activeStudent?.getAttribute('data-id');

	if (!studentId) {
		throw new Error('Select or Add a Student to continue');
	}

	if (type === 'party') {
		return fetchPartySelectionData(studentId);
	} else {
		return fetchClassSelectionData(studentId);
	}
}

async function handleBravoBashSelectionStep() {
	const activeStudent = document.querySelector('.current-student.active');
	studentId = activeStudent?.getAttribute('data-id');

	if (!studentId) {
		throw new Error('Select a Student to continue');
	}

	return fetchBravoBashSelectionData(studentId);
}

// Creates a student if needed
async function createStudent() {
	const firstName = document.getElementById('first_name')?.value.trim();
	const lastName = document.getElementById('last_name')?.value.trim();
	let dob = document.getElementById('dob')?.value.trim();

	if (!validateStudentInput(firstName, lastName, dob)) {
		throw new Error(
			"Add your student's First Name, Last Name and Date of Birth to continue."
		);
	}

	const businessName = document
		.querySelector('#business_slug')
		?.value?.toLowerCase();

	if (businessName === 'salisbury') {
		// Convert from DD/MM/YYYY to MM/DD/YYYY
		const [day, month, year] = dob.split('/');
		dob = `${month}/${day}/${year}`;
	}

	const params = { first_name: firstName, last_name: lastName, dob: dob };
	const data = await fetchClassBugData(1, 'create_student', params, 'POST');
	return data?.student?.id;
}

// Validates student input
function validateStudentInput(firstName, lastName, dob) {
	if (!firstName || firstName.length < 2) return false;
	if (!lastName || lastName.length < 2) return false;

	const businessName = document
		.querySelector('#business_slug')
		?.value?.toLowerCase();

	if (businessName === 'salisbury') {
		// UK format: DD/MM/YYYY
		if (
			!dob ||
			!/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/.test(dob)
		)
			return false;
	} else {
		// US format: MM/DD/YYYY
		if (
			!dob ||
			!/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/.test(dob)
		)
			return false;
	}

	return true;
}

async function handleContactInformationStep() {
	try {
		const cell_phone = document.getElementById('cell_phone')?.value.trim();
		if (!validateInput(cell_phone)) {
			throw new Error('Please add your Cell Phone');
		}
		const home_phone = document.getElementById('home_phone')?.value.trim();
		const address = document.getElementById('address')?.value.trim();
		if (!validateInput(address)) {
			throw new Error('Please add your Address');
		}
		const city = document.getElementById('city')?.value.trim();
		if (!validateInput(city)) {
			throw new Error('Please add your City');
		}
		const state = document.getElementById('state')?.value.trim();
		if (!validateInput(state)) {
			throw new Error('Please add your State');
		}
		const zipcode = document.getElementById('zip')?.value.trim();
		if (!validateInput(zipcode)) {
			throw new Error('Please add your Zip Code');
		}
		const ec_name = document.getElementById('ec_name')?.value.trim();
		if (!validateInput(ec_name)) {
			throw new Error('Please add your Emergency Contact Name');
		}
		const ec_phone = document.getElementById('ec_phone')?.value.trim();
		if (!validateInput(ec_phone)) {
			throw new Error('Please add your Emergency Contact Phone');
		}

		const normalizePhone = (val) => val?.replace(/\D/g, '');

		if (
			normalizePhone(ec_phone) === normalizePhone(cell_phone) ||
			(validateInput(home_phone) &&
				normalizePhone(ec_phone) === normalizePhone(home_phone))
		) {
			throw new Error(
				'Emergency Contact must be different from primary caregiver info'
			);
		}

		const special_conditions = document
			.getElementById('special_conditions')
			?.value.trim();
		const referral = document.getElementById('referral')?.value.trim();
		if (!validateInput(referral)) {
			throw new Error('Please add how you heard about us');
		}
		const referral_comment = document
			.getElementById('referral_comment')
			?.value.trim();

		const consentCheckbox = document.getElementById('data-consent');
		if (special_conditions && consentCheckbox && !consentCheckbox.checked) {
			throw new Error('The consent must be checked before continuing.');
		}

		const params = {
			event_attendee_id: studentId,
			registration_type: getRegistrationType(),
			cell_phone: cell_phone,
			home_phone: home_phone,
			address: address,
			city: city,
			state: state,
			zipcode: zipcode,
			ec_name: ec_name,
			ec_phone: ec_phone,
			special_conditions: special_conditions,
			referral: referral,
			referral_comment: referral_comment,
		};
		const data = await fetchClassBugData(
			1,
			'update_registration_info',
			params,
			'POST'
		);
	} catch (error) {
		console.error('API Error:', error);
		throw error;
	}
}

function validateInput(input) {
	if (!input || input.length < 2) return false;
	return true;
}

function updatePriceId(price) {
	const priceElement = document.getElementById('price');
	priceElement.value = (price / 100).toFixed(2);
}

// Fetches additional class selection data
async function fetchBravoBashSelectionData(studentId) {
	try {
		const selectCostumes = document.getElementById('costumes');
		const offeringId = document.getElementById('bravo_bash_offering_id');
		const btnContact = document.getElementById('btn-contact');

		const bravoBashes = await fetchClassBugData(1, 'get_bb_offering', '');

		if (!bravoBashes) {
			throw new Error('No Bravo Bash data found.');
		}

		const classTitles = document.querySelectorAll('.class-title');
		const classPrices = document.querySelectorAll('.class-price');

		// Update class description fields
		if (
			typeof bravoBashes.name === 'string' &&
			bravoBashes.name.trim().length > 0
		) {
			classTitles.forEach((el) => {
				el.textContent = bravoBashes.name;
			});
		}

		if (!isNaN(bravoBashes.price) && bravoBashes.price !== 0) {
			classPrices.forEach((el) => {
				el.textContent =
					getCurrency() +
					(bravoBashes.price / 100).toFixed(2) +
					getCurrencyPostfix();
			});

			updatePriceId(bravoBashes.price);
		}

		offeringId.value = bravoBashes.offering_id;

		if (
			bravoBashes.costume_choices &&
			bravoBashes.costume_choices.length > 0
		) {
			if (selectCostumes) {
				selectCostumes.innerHTML = '<option value="">Select</option>';
				const fragment = document.createDocumentFragment();
				bravoBashes.costume_choices.forEach(
					({ costume_id, costume_name }) => {
						const option = document.createElement('option');
						option.value = costume_id;
						option.textContent = costume_name;
						fragment.appendChild(option);
					}
				);
				selectCostumes.appendChild(fragment);
			}
		} else {
			const costumeSelector = document.querySelector('.costume-selector');
			const btnContact = document.getElementById('btn-contact');
			if (btnContact) {
				btnContact.disabled = false;
			}
			if (costumeSelector) {
				costumeSelector.style.display = 'none';
			}
		}

		if (bravoBashes.details) {
			const bbDetails = document.getElementById('bb-details');
			if (bbDetails) {
				bbDetails.innerHTML = '<p>' + bravoBashes.details + '</p>';
			}
		}
	} catch (error) {
		console.error('API Error:', error);
		throw error;
	}
}

function validateFormFields() {
	const partySelect = document.getElementById('partySelect');
	const daySelect = document.getElementById('daySelect');
	const timeSelect = document.getElementById('timeSelect');
	const guestsInput = document.getElementById('guests');
	const btnContact = document.getElementById('btn-contact');

	const isComplete = Boolean(
		partySelect.value &&
		daySelect.value &&
		timeSelect.value &&
		guestsInput.value
	);

	const classTitleDiv = document.querySelector('.class-title');
	const classTimeDiv = document.querySelector('.class-time');

	// Get the selected option names
	const selectedPartyName =
		partySelect.options[partySelect.selectedIndex]?.text ||
		'Select a party';
	const selectedDayName =
		daySelect.options[daySelect.selectedIndex]?.text || 'Select a day';
	const selectedTimeName =
		timeSelect.options[timeSelect.selectedIndex]?.text || 'Select a time';

	// Update the respective elements with the names
	classTitleDiv.textContent = selectedPartyName;
	classTimeDiv.textContent = `${selectedDayName} - ${selectedTimeName}`;

	btnContact.disabled = !isComplete;
}

// Fetches additional class selection data
async function fetchPartySelectionData(studentId) {
	try {
		const partySelect = document.getElementById('partySelect');
		const daySelect = document.getElementById('daySelect');
		const timeSelect = document.getElementById('timeSelect');
		const guestsInput = document.getElementById('guests');
		const btnContact = document.getElementById('btn-contact');

		partySelect.addEventListener('change', validateFormFields);
		daySelect.addEventListener('change', validateFormFields);
		timeSelect.addEventListener('change', validateFormFields);
		guestsInput.addEventListener('input', validateFormFields);

		let allAvailable = []; // this gets filled by getAllAvailableDays(apiResponse)
		let selectedParty = null;

		// Populate the party select
		function populateParties(data) {
			allAvailable = data;

			for (let i = partySelect.options.length - 1; i >= 0; i--) {
				// Remove all parties before adding them
				if (partySelect.options[i].value !== '') {
					partySelect.remove(i);
				}
			}
			data.forEach((party) => {
				const option = document.createElement('option');
				option.value = party.party_id;
				option.textContent = party.name;
				option.setAttribute('data-price', party.price);
				option.setAttribute('data-deposit', party.deposit_amount);
				partySelect.appendChild(option);
			});
		}

		const parties = await fetchClassBugData(1, 'get_parties', '');

		if (!parties?.length) throw new Error('No Parties found.');

		const structuredData = getAvailableDays(parties); // use previous function
		populateParties(structuredData); // fill first dropdown

		// When party is selected, populate the day select
		partySelect.addEventListener('change', () => {
			const partyId = parseInt(partySelect.value);
			const partyText =
				partySelect.options[partySelect.selectedIndex].text;

			document
				.querySelectorAll('.party-info')
				.forEach((btn) => btn.classList.remove('active'));

			const partyMap = {
				'Fairy Tale Party': 'odette',
				'Odette Ballet Birthday Party': 'odette',
				'Cinderella Ballet Birthday Party': 'cinderella',
				'Sugar Plum Ballet Birthday Party': 'sugar_plum',
			};

			const type = partyMap[partyText];
			if (type) {
				document
					.querySelector(`.party-info[data-type="${type}"]`)
					?.classList.add('active');
			}

			selectedParty = allAvailable.find((p) => p.party_id === partyId);
			updateTotalPrice();

			daySelect.innerHTML = '<option value="">Select a day</option>';
			timeSelect.innerHTML = '<option value="">Select a time</option>';
			timeSelect.disabled = true;

			if (selectedParty && selectedParty.available_days.length > 0) {
				const addOnContainer =
					document.getElementById('addOnContainer');
				addOnContainer.innerHTML = ''; // Clear old checkboxes

				if (selectedParty && selectedParty.add_ons?.length > 0) {
					selectedParty.add_ons.forEach((addOn) => {
						const wrapper = document.createElement('label');
						wrapper.style.display = 'block'; // stack checkboxes

						const checkbox = document.createElement('input');
						checkbox.type = 'checkbox';
						checkbox.name = 'add_ons[]';
						checkbox.className = 'radio';
						checkbox.value = addOn.add_on_id;
						checkbox.setAttribute('data-price', addOn.add_on_price);
						checkbox.setAttribute('data-id', addOn.add_on_id);
						checkbox.addEventListener('change', updateTotalPrice);

						wrapper.appendChild(checkbox);
						wrapper.append(
							` ${addOn.add_on_name} ($${(addOn.add_on_price / 100).toFixed(2)})`
						);

						addOnContainer.appendChild(wrapper);
					});
				}

				selectedParty.available_days.forEach((day) => {
					const option = document.createElement('option');
					option.value = day.date;
					option.textContent = DateTime.fromISO(day.date).toFormat(
						'cccc, MM/dd/yyyy'
					);
					daySelect.appendChild(option);
				});

				daySelect.disabled = false;
			} else {
				daySelect.disabled = true;
			}
		});

		// When day is selected, populate the time select
		daySelect.addEventListener('change', () => {
			const selectedDate = daySelect.value;
			const day = selectedParty?.available_days.find(
				(d) => d.date === selectedDate
			);

			timeSelect.innerHTML = '<option value="">Select a time</option>';

			if (day) {
				day.slots.forEach((slot) => {
					const option = document.createElement('option');
					option.value = `${slot.start}-${slot.end}`;
					option.textContent = `${slot.start} - ${slot.end}`;
					timeSelect.appendChild(option);
				});

				timeSelect.disabled = false;
			} else {
				timeSelect.disabled = true;
			}
		});
	} catch (error) {
		console.error('API Error:', error);
		throw error;
	}
}

function updateTotalPrice() {
	const partySelect = document.getElementById('partySelect');
	const classPriceDivs = document.querySelectorAll('.class-price');
	const depositPriceDivs = document.querySelectorAll('.deposit-price');

	let total = 0;
	let deposit = 0;

	// Get party price from selected option
	const selectedOption = partySelect.options[partySelect.selectedIndex];
	if (selectedOption && selectedOption.dataset.price) {
		total += parseInt(selectedOption.dataset.price);
	}
	if (selectedOption && selectedOption.dataset.deposit) {
		deposit += parseInt(selectedOption.dataset.deposit);
	}

	// Add up selected add-ons
	const checkedAddOns = document.querySelectorAll(
		'input[name="add_ons[]"]:checked'
	);
	checkedAddOns.forEach((cb) => {
		total += parseInt(cb.dataset.price);
	});

	// Format to $XXX.XX
	const formatted = `${getCurrency()}${(total / 100).toFixed(2)}${getCurrencyPostfix()}`;
	const formattedDeposit = `${getCurrency()}${(deposit / 100).toFixed(2)}${getCurrencyPostfix()}`;

	// Update all matching elements
	classPriceDivs.forEach((div) => {
		div.textContent = formatted;
	});

	depositPriceDivs.forEach((div) => {
		div.textContent = formattedDeposit;
	});

	updatePriceId(deposit);
}

// Fetches additional class selection data
async function fetchClassSelectionData(studentId) {
	try {
		const selectClass = document.getElementById('class');
		const selectTimes = document.getElementById('times');
		const selectAvailable = document.getElementById('trial_event_id');
		const btnContact = document.getElementById('btn-contact');
		const registrationType = getRegistrationType();
		showTrial(registrationType);

		const params = { registration_type: registrationType };
		const subCategories = await fetchClassBugData(
			1,
			'get_subcategories',
			params
		);

		if (!subCategories?.length) {
			throw new Error('No subcategories found.');
		}

		const keyword =
			registrationType === 'CAMP'
				? 'camp'
				: registrationType === 'EVENT'
					? 'events'
					: 'classes';
		const match = subCategories.find((sub) =>
			sub.subcategory_name.toLowerCase().includes(keyword.toLowerCase())
		);

		const subcategoryId = match ? match.subcategory_id : null;
		selectTimes.innerHTML = '';
		selectTimes.disabled = true;
		btnContact.disabled = true;
		const gatewayClasses = await fetchClassBugData(
			1,
			'get_gateway_classes',
			{
				event_attendee_id: studentId,
				subcategory_id: subcategoryId,
				registration_type: registrationType,
			}
		);

		if (gatewayClasses?.error) {
			document.querySelectorAll('.error-message').forEach((btn) => {
				btn.textContent = gatewayClasses?.error;
			});
			document
				.querySelectorAll('.show-error')
				.forEach((btn) => btn.classList.add('active'));
			document
				.querySelectorAll('.hide-error')
				.forEach((btn) => btn.classList.add('active'));
			return;
		} else {
			document
				.querySelectorAll('.show-error')
				.forEach((btn) => btn.classList.remove('active'));
			document
				.querySelectorAll('.hide-error')
				.forEach((btn) => btn.classList.remove('active'));
		}
		if (!gatewayClasses?.length) return;

		// Clear and populate class dropdown
		selectClass.innerHTML = '<option value="">Select</option>';
		const fragment = document.createDocumentFragment();
		gatewayClasses.forEach(
			({ gateway_offering_id, name, price, description }) => {
				const option = document.createElement('option');
				option.value = gateway_offering_id;
				option.textContent = name;
				option.dataset.price = price;
				option.dataset.description =
					description === null || description === 'null'
						? ''
						: description;
				fragment.appendChild(option);
			}
		);
		selectClass.appendChild(fragment);

		// Attach event listeners only once
		if (!selectClass.dataset.listener) {
			selectClass.addEventListener('change', () =>
				handleClassChange(
					selectClass,
					selectTimes,
					subcategoryId,
					studentId,
					btnContact
				)
			);
			selectClass.dataset.listener = 'true';
		}

		if (!selectTimes.dataset.listener) {
			selectTimes.addEventListener('change', () =>
				handleTimesChange(selectClass, selectTimes, btnContact)
			);
			selectTimes.dataset.listener = 'true';
		}

		if (selectAvailable) {
			if (!selectAvailable.dataset.listener) {
				selectAvailable.addEventListener('change', () =>
					handleAvailableChange(
						selectClass,
						selectTimes,
						selectAvailable,
						btnContact
					)
				);
				selectAvailable.dataset.listener = 'true';
			}
		}
	} catch (error) {
		console.error('API Error:', error);
		throw error;
	}
}

// Handle class selection change
async function handleClassChange(
	selectClass,
	selectTimes,
	subcategoryId,
	studentId,
	btnContact
) {
	btnContact.disabled = true;

	const selectedOption = selectClass.options[selectClass.selectedIndex];
	const selectedValue = selectedOption.value;
	const selectedName = selectedOption.textContent;
	const selectedPrice = selectedOption.dataset.price;
	const selectedDescription = selectedOption.dataset.description;
	const availableTimesSelect = document.getElementById('trial_event_id');

	if (availableTimesSelect) {
		availableTimesSelect.disabled = true;
		availableTimesSelect.innerHTML =
			'<option value="">Select Trial Date</option>';
	}

	const classDescription = document.getElementById('class-description');
	const classDescriptionText = document.querySelector('.class-description');
	const classTitles = document.querySelectorAll('.class-title');
	const classPrices = document.querySelectorAll('.class-price');
	const depositPriceDivs = document.querySelectorAll('.deposit-price');
	const deposit = document.getElementById('deposit_amount');

	if (!selectedValue) {
		selectTimes.disabled = true;
		selectTimes.innerHTML = '<option value="">Select Time</option>';
		classDescription.classList.add('hidden');
		return;
	}

	// Update class description fields
	classTitles.forEach((el) => {
		el.textContent = selectedName;
	});

	const registrationType = getRegistrationType();

	const price = Number(selectedPrice);

	if (!isNaN(price) && price !== 0) {
		classPrices.forEach((el) => {
			el.textContent =
				getCurrency() + (price / 100).toFixed(2) + getCurrencyPostfix();
		});
		updatePriceId(price);

		if (registrationType === 'EVENT') {
			setRegistrationPrice(price);
			checkPayment('event', price);
		}
	} else {
		if (registrationType === 'EVENT') {
			setRegistrationPrice(0);
			checkPayment('event', 0);
		}
	}

	if (
		typeof selectedDescription === 'string' &&
		selectedDescription.trim().length > 0
	) {
		classDescriptionText.textContent = selectedDescription;
		classDescription.classList.remove('hidden');
	}

	if (depositPriceDivs && deposit) {
		const depositAmount = deposit.value / 100;
		const formattedDeposit = `${getCurrency()}${depositAmount.toFixed(2)}${getCurrencyPostfix()}`;

		depositPriceDivs.forEach((div) => {
			div.textContent = formattedDeposit;
		});

		const productPrice = price / 100;
		const depositHideEls = document.querySelectorAll('.deposit-hide');

		depositHideEls.forEach((el) => {
			if (productPrice < depositAmount) {
				el.style.display = 'none';
			} else {
				el.style.display = 'block';
			}
		});
	}

	try {
		const classTimes = await fetchClassBugData(1, 'get_eligible_classes', {
			event_attendee_id: studentId,
			subcategory_id: subcategoryId,
			gateway_offering_id: selectedValue,
			gateway_offering_name: selectedName,
			registration_type: registrationType,
		});

		if (classTimes?.error) {
			alert(classTimes.error);
		} else {
			// Proceed with using classTimes
			selectTimes.disabled = !classTimes?.length;
			selectTimes.innerHTML = '<option value="">Select Time</option>';

			if (classTimes?.length) {
				const fragment = document.createDocumentFragment();
				classTimes.forEach(
					({
						offering_id,
						days_of_week,
						start_time,
						end_time,
						available_trial_dates,
						is_waitlist,
					}) => {
						const option = document.createElement('option');
						option.value = offering_id;
						option.textContent = `${days_of_week.join(', ')} - ${start_time} ${registrationType === 'CAMP' ? (end_time ? end_time : '') : ''} ${is_waitlist ? '- WAITLIST' : ''}`;
						option.dataset.available_days = JSON.stringify(
							available_trial_dates
						);
						option.dataset.waitlist = is_waitlist;
						fragment.appendChild(option);
					}
				);
				selectTimes.appendChild(fragment);
			}
		}
	} catch (error) {
		console.error('Fetch failed:', error);
		alert('Something went wrong while fetching class times.');
	}
}

// Handle time selection change
function handleTimesChange(selectClass, selectTimes, btnContact) {
	const registrationType = getRegistrationType();

	if (registrationType === 'TRIAL') {
		btnContact.disabled = true;
		const availableTimesSelect = document.getElementById('trial_event_id');
		const select = document.getElementById('times');
		const selectedOption = select.options[select.selectedIndex];
		const storedData = selectedOption.getAttribute('data-available_days');
		const parsedData = JSON.parse(storedData);

		availableTimesSelect.disabled = !parsedData?.length;
		let selectText = 'Select Trial Date';
		if (!parsedData?.length) {
			selectText = 'No Available Trial Dates';
		}
		availableTimesSelect.innerHTML = `<option value="">${selectText}</option>`;

		if (availableTimesSelect?.length) {
			const fragment = document.createDocumentFragment();
			parsedData.forEach((trial) => {
				const option = document.createElement('option');
				option.value = trial.trial_event_id;
				option.textContent = `${trial.trial_date}`;
				fragment.appendChild(option);
			});
			availableTimesSelect.appendChild(fragment);
		}
	} else {
		btnContact.disabled = !(selectClass.value && selectTimes.value);
		const classTimes = document.querySelectorAll('.class-time');
		if (selectClass.value && selectTimes.value) {
			const selectedText = selectTimes.selectedOptions[0].textContent;
			classTimes.forEach((el) => {
				el.textContent = selectedText;
			});
			if (registrationType !== 'BB') {
				setWaitlist(selectTimes.selectedOptions[0].dataset.waitlist);
			}
		} else {
			classTimes.forEach((el) => {
				el.textContent = '';
			});
		}
	}
}

function handleAvailableChange(
	selectClass,
	selectTimes,
	selectAvailable,
	btnContact
) {
	btnContact.disabled = !(
		selectClass.value &&
		selectTimes.value &&
		selectAvailable.value
	);

	const classTimes = document.querySelectorAll('.class-time');
	if (selectClass.value && selectTimes.value && selectAvailable.value) {
		const selectedText =
			selectTimes.selectedOptions[0].textContent +
			' | ' +
			selectAvailable.selectedOptions[0].textContent;
		classTimes.forEach((el) => {
			el.textContent = selectedText;
		});
	} else {
		classTimes.forEach((el) => {
			el.textContent = '';
		});
	}
}

async function handlePaymentInformation() {
	try {
		const paymentOptions = document.getElementById('paymentOptions');
		const completeRegistration = document.getElementById(
			'complete-registration'
		);
		if (!paymentOptions) return;

		//
		// 1️⃣ Get payment methods from API
		//
		const paymentMethods = await fetchClassBugData(
			1,
			'get_payment_methods',
			'',
			'GET'
		);

		//
		// 2️⃣ Get store credit from API
		//
		const storeCreditResponse = await fetchClassBugData(
			1,
			'get_store_credit',
			'',
			'GET'
		);

		const storeCredit = storeCreditResponse?.store_credit ?? null; // may be number or null

		//
		// 3️⃣ Clear only payment-cards (so we always render fresh)
		//
		paymentOptions.innerHTML = '';

		//
		// 4️⃣ Render PAYMENT TYPE buttons (not gift card)
		//
		if (Array.isArray(paymentMethods) && paymentMethods.length) {
			const buttonsHTML = paymentMethods
				.filter((item) => item.token !== 'gift-card') // defensive
				.map((item) => {
					return `
            <button 
              data-token="${item.token}"
              class="btn btn-purple payment-card no-icon relative">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-[30px] absolute left-4 transition-all"
                   viewBox="0 0 640 640">
                <path d="M320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576zM438 209.7C427.3 201.9 412.3 204.3 404.5 215L285.1 379.2L233 327.1C223.6 317.7 208.4 317.7 199.1 327.1C189.8 336.5 189.7 351.7 199.1 361L271.1 433C276.1 438 282.9 440.5 289.9 440C296.9 439.5 303.3 435.9 307.4 430.2L443.3 243.2C451.1 232.5 448.7 217.5 438 209.7z" />
              </svg>
              ${item.description}
            </button>`;
				})
				.join('');

			paymentOptions.insertAdjacentHTML('beforeend', buttonsHTML);
		}

		//
		// 5️⃣ Add GIFT CARD button ONLY if store_credit is valid
		//
		if (storeCredit && !isNaN(storeCredit) && storeCredit > 0) {
			// Convert cents → dollars (4500 → 45.00)
			const creditAmount = (storeCredit / 100).toFixed(2);

			const giftCardBtn = document.createElement('button');
			giftCardBtn.dataset.token = 'gift-card';
			giftCardBtn.dataset.amount = creditAmount;
			giftCardBtn.className =
				'btn btn-purple payment-card no-icon relative';

			giftCardBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" class="w-[30px] absolute left-4 transition-all"
             viewBox="0 0 640 640">
          <path d="M320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576zM438 209.7C427.3 201.9 412.3 204.3 404.5 215L285.1 379.2L233 327.1C223.6 317.7 208.4 317.7 199.1 327.1C189.8 336.5 189.7 351.7 199.1 361L271.1 433C276.1 438 282.9 440.5 289.9 440C296.9 439.5 303.3 435.9 307.4 430.2L443.3 243.2C451.1 232.5 448.7 217.5 438 209.7z"></path>
        </svg>
        Store Credit $${creditAmount}
      `;

			paymentOptions.appendChild(giftCardBtn);

			const giftCardMessage = document.querySelector('#giftcard');
			giftCardMessage.classList.remove('hidden');
		}

	} catch (error) {
		console.error('API Error:', error);
		throw error;
	}
}

/*
Promo Codes
*/
let isPromoCodeValid = false;

async function getPromoCodes() {
	try {
		const data = await fetchClassBugData(
			1,
			'get_valid_promo_codes',
			'',
			'GET'
		);
		if (data?.length) {
			return data;
		}
	} catch (error) {
		console.error('API Error:', error);
		throw error;
	}
}

const promoCodeButton = document.getElementById('check_promo_code');

if (promoCodeButton) {
	document
		.getElementById('check_promo_code')
		.addEventListener('click', async function () {
			const button = this;
			const input = document.getElementById('promo_code');
			const messageLabel = document.getElementById('promo_message');

			// If already validated, reset state
			if (button.textContent === 'Reset') {
				isPromoCodeValid = false;
				input.disabled = false;
				input.value = '';
				messageLabel.textContent = 'Add Promo code';
				button.textContent = 'Submit';
				return;
			}

			const userInput = input.value.trim().toLowerCase();
			isPromoCodeValid = false;

			if (!userInput) {
				messageLabel.textContent = 'Please enter a promo code';
				return;
			}

			button.textContent = 'Checking';
			messageLabel.textContent = '';

			try {
				const validCodes = await getPromoCodes();
				const normalizedCodes = validCodes.map((code) =>
					code.toLowerCase()
				);

				if (normalizedCodes.includes(userInput)) {
					messageLabel.innerHTML =
						'<strong>Code accepted.</strong> Your studio will adjust your balance after registration';
					isPromoCodeValid = true;
					input.disabled = true;
					button.textContent = 'Reset';
				} else {
					messageLabel.textContent = 'Invalid promo code';
					button.textContent = 'Submit';
				}
			} catch (error) {
				messageLabel.textContent = 'Error checking promo code.';
				console.error('Error during promo code check:', error);
				button.textContent = 'Submit';
			}
		});
}

function getSelectedDateTimeISO() {
	const day = document.getElementById('daySelect').value; // "2025-04-13"
	const time = document.getElementById('timeSelect').value; // "1:00 PM - 2:00 PM" or "1:00 PM"

	if (!day || !time) return null;

	const startTime = time.split('-')[0].trim(); // "1:00 PM"

	// Use fromFormat to parse AM/PM style time
	const dt = DateTime.fromFormat(`${day} ${startTime}`, 'yyyy-MM-dd h:mm a', {
		zone: 'UTC',
	});

	// Format without offset or milliseconds
	return dt.toISO({ includeOffset: false, suppressMilliseconds: true });
}

function getSelectedAddOnIds() {
	const checkedAddOns = document.querySelectorAll(
		'input[name="add_ons[]"]:checked'
	);
	const addOnIds = Array.from(checkedAddOns).map((cb) => parseInt(cb.value));
	return addOnIds;
}

function getUTCISOString(date = new Date()) {
	return date.toISOString().split('.')[0] + 'Z';
}

function getClassValue() {
	// Try to find a .deposit-price first
	const deposit = document.querySelector('.deposit-price');
	if (deposit && deposit.textContent) {
		return parseFloat(deposit.textContent.replace(/[$£,]/g, '').trim());
	}

	// If no .deposit-price, try .class-price
	const classPrice = document.querySelector('.class-price');
	if (classPrice && classPrice.textContent) {
		return parseFloat(classPrice.textContent.replace(/[$£,]/g, '').trim());
	}

	return null; // Return null if nothing is found
}

function getClassDateAndTime() {
	const times = document.getElementById('times');
	if (!times || !times.selectedOptions.length)
		return { classdate: null, classtime: null };

	const text = times.selectedOptions[0].textContent || '';
	const [date, time] = text.split(' - ').map((str) => str.trim());

	return {
		classdate: date || null,
		classtime: time || null,
	};
}

async function submitRegistration() {
	try {
		const activePaymentType = document.querySelector(
			'.payment-card.active:not([data-token="gift-card"])'
		);
		const times = document.getElementById('times');
		const trial_event_id = document.getElementById('trial_event_id');
		const bb_offering_id = document.getElementById(
			'bravo_bash_offering_id'
		);
		const bb_comment = document.getElementById('bb_comment');
		const costume = document.getElementById('costumes');
		const paymentToken = activePaymentType?.getAttribute('data-token');
		const registrationType = getRegistrationType();
		const timestamp = getUTCISOString();
		const value = getClassValue();
		const activeGiftCardBtn = document.querySelector(
			'button[data-token="gift-card"].active'
		);

		if (localStorage.getItem('requirePayment') === '1') {
			if (!paymentToken && !activeGiftCardBtn) {
				throw new Error(
					'No payment selected. Please select a payment method to continue.'
				);
			}
		}

		if (registrationType === 'PARTY') {
			const party_id = document.getElementById('partySelect');
			const guests = document.getElementById('guests');

			const params = {
				event_attendee_id: studentId,
				registration_type: 'PARTY',
				party_id: party_id.value,
				tos_status: true,
				payment_method_token: paymentToken,
				party_start_time: getSelectedDateTimeISO(),
				guest_count: guests.value,
			};

			if (activeGiftCardBtn) {
				params.use_store_credit = 'true';

				if (!paymentToken) {
					params.payment_method_token = 'store_credit_token';
				}
			}

			try {
				const data = await fetchClassBugData(
					1,
					'submit_party_rental',
					params,
					'POST'
				);
				if (data?.error) {
					throw new Error(data.error);
				}

				try {
					await registrationStep(data);
				} catch (err) {
					console.error('Caught in submitRegistration:', err);
					showErrorScreen(err); // err should now be defined
					throw err;
				}

				pushRegistrationEvent('partyRegistrationSuccess', {
					classID: party_id.value,
					locationID: document
						.getElementById('business_slug')
						?.value.trim(),
					classdate: document.getElementById('daySelect').value,
					classtime: document.getElementById('timeSelect').value,
					timestamp: timestamp,
					value: value,
					currency: 'USD',
				});
			} catch (err) {
				console.error('Party Rental Submission Failed:', err);
				throw err;
			}
		} else {
			const params = {
				event_attendee_id: studentId,
				registration_type: registrationType,
				tos_status: true,
				offering_id:
					registrationType === 'BB'
						? bb_offering_id.value
						: times.value,
				is_waitlist: getWaitlist(),
				trial_event_id:
					registrationType === 'TRIAL' ? trial_event_id.value : '',
				bb_costume_id:
					registrationType === 'BB' && costume?.value
						? costume.value
						: '',
				bb_comment: bb_comment ? bb_comment.value : '',
				info_sms: document.getElementById('data-consent-transactional')
					.checked
					? true
					: false,
				marketing_sms: document.getElementById('data-consent-marketing')
					.checked
					? true
					: false,
			};
			let successType = 'classRegistrationSuccess';
			const requirePayment =
				localStorage.getItem('requirePayment') === '1';
			const waitlisted = getWaitlist() === 'true' ? 'true' : '';

			// Base types
			if (registrationType === 'CAMP') {
				successType = 'campRegistrationSuccess';
				params.payment_method_token = paymentToken;
			} else if (registrationType === 'EVENT') {
				successType = 'eventRegistrationSuccess';
				params.payment_method_token = requirePayment
					? paymentToken
					: 'event_token';
			} else if (registrationType === 'TRIAL') {
				successType = 'trialRegistrationSuccess';
				params.payment_method_token = requirePayment
					? paymentToken
					: 'trial_token';
			} else if (registrationType === 'BB') {
				successType = 'bravobashRegistrationSuccess';
				params.payment_method_token = requirePayment
					? paymentToken
					: 'event_token';
			} else if (requirePayment && waitlisted) {
				successType = 'waitlistRegistrationSuccess';
				params.payment_method_token = paymentToken;
			} else if (!requirePayment && waitlisted) {
				successType = 'waitlistRegistrationSuccess';
				params.payment_method_token = 'wl_token';
			} else {
				params.payment_method_token = paymentToken;
			}

			if (isPromoCodeValid) {
				const promo = document
					.getElementById('promo_code')
					.value.trim();
				if (promo) {
					params.promo_code = promo;
				}
			}

			const activeGiftCardBtn = document.querySelector(
				'button[data-token="gift-card"].active'
			);

			if (activeGiftCardBtn) {
				params.use_store_credit = 'true';

				if (!paymentToken) {
					params.payment_method_token = 'store_credit_token';
				}
			}

			try {
				const data = await fetchClassBugData(
					1,
					'submit_registration',
					params,
					'POST'
				);
				if (data?.error) {
					throw new Error(data.error);
				}

				if (waitlisted !== 'true') {
					try {
						await registrationStep(data);
					} catch (err) {
						console.error('Caught in submitRegistration:', err);
						showErrorScreen(err); // err should now be defined
						throw err;
					}
				}

				const { classdate, classtime } = getClassDateAndTime();

				pushRegistrationEvent(successType, {
					classID:
						registrationType === 'BB'
							? bb_offering_id.value
							: times.value,
					locationID: document
						.getElementById('business_slug')
						?.value.trim(),
					classdate,
					classtime,
					timestamp: timestamp,
					value: value,
					currency: 'USD',
				});
			} catch (err) {
				console.error('Registration Submission Failed:', err);
				throw err;
			}
		}
	} catch (error) {
		console.error('API Error:', error);
		throw error;
	}
}

function pushRegistrationEvent(eventName, details) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: eventName,
		registrationDetails: details,
	});
}

function showErrorScreen(err) {
	const completeRegistration = document.getElementById(
		'complete-registration'
	);
	if (completeRegistration) {
		completeRegistration.innerHTML = 'Complete Registration';
		completeRegistration.disabled = false;
	}

	const errorMessage = document.getElementById('error-message');
	if (errorMessage) {
		const exception = err?.exception || '';
		const message = err?.message || 'Something went wrong.';

		errorMessage.innerHTML = `
      <div class="my-4">
        <div class="p-5 bg-neutral-light rounded-[20px] mt-5 text-center">
          <p class="eyebrow">${exception}</p>
          <p>${message}</p>
        </div>
      </div>`;
	}
}

async function waitForRegistrationCompletion(
	registrationId,
	interval = 2000,
	timeout = 60000,
	method = 'GET'
) {
	const startTime = Date.now();

	while (true) {
		const registrationStatus = await fetchClassBugData(
			1,
			'get_registration_status',
			{
				checkout_job_status_id: registrationId,
			},
			method
		);

		if (registrationStatus?.checkout_status !== 'pending') {
			if (registrationStatus?.checkout_status === 'error') {
				console.error('Throwing error data:', registrationStatus);
				throw registrationStatus;
			}
			return registrationStatus;
		}

		// Check timeout
		if (Date.now() - startTime >= timeout) {
			throw new Error('Timeout waiting for registration to complete');
		}

		// Wait before polling again
		await new Promise((resolve) => setTimeout(resolve, interval));
	}
}

async function registrationStep(data) {
	const registrationId =
		data.waiting_list_entry_id || data.checkout_job_status_id;

	try {
		const registrationStatus =
			await waitForRegistrationCompletion(registrationId);
		/*
				if (registrationStatus) {
					const refresh = document.getElementById('refresh-status');
					if (refresh) {
						refresh.setAttribute('data-id', registrationId);
						setStatus(registrationStatus);
					}
				}
		 */
	} catch (err) {
		// ✅ propagate the original error
		throw err;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const acceptTerms = document.getElementById('accept_terms');
	if (!acceptTerms) return;

	const acceptMonthly = document.getElementById('accept_monthly');
	const termsButtons = document.querySelectorAll('.terms-button');

	function isVisible(el) {
		return !!(el && el.offsetParent !== null); // true if element is rendered and visible
	}

	function updateButtonState() {
		const termsChecked = acceptTerms?.checked;
		const monthlyChecked = isVisible(acceptMonthly)
			? acceptMonthly.checked
			: true; // treat as "not required" if hidden

		termsButtons.forEach((button) => {
			button.disabled = !(termsChecked && monthlyChecked);
		});
	}

	acceptTerms.addEventListener('change', updateButtonState);

	if (acceptMonthly) {
		acceptMonthly.addEventListener('change', updateButtonState);
	}

	updateButtonState(); // run on page load
});

function fetchClassBugData(businessId, endpoint, params = {}, method = 'GET') {
	return new Promise((resolve, reject) => {
		fetch('/wp-admin/admin-ajax.php', {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: new URLSearchParams({
				action: 'get_classbug_data',
				business_id: document
					.getElementById('business_id')
					?.value.trim(),
				endpoint: endpoint,
				params: JSON.stringify(params), // Convert params to JSON string
				method: method,
				token: 1,
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.success) {
					resolve(data.data);
				} else {
					reject(data);
				}
			})
			.catch((error) => reject(error));
	});
}

// Function to Play Lottie Confetti Animation
function playConfettiAnimation() {
	const confettiContainer = document.getElementById('confettiLottie');
	if (confettiContainer && typeof lottie !== 'undefined') {
		lottie.loadAnimation({
			container: confettiContainer,
			renderer: 'svg',
			loop: false,
			autoplay: true,
			path: themeData.confetti, // Path to your confetti Lottie JSON file
		});
	}
}

function setStatus(registrationStatus) {
	if (registrationStatus) {
		const status = document.querySelector('.status');
		const statusMessage = document.querySelector('.status-message');
		status.textContent = registrationStatus.checkout_status;
		statusMessage.textContent = registrationStatus.message;
		if (registrationStatus.checkout_status === 'complete') {
			const refresh = document.getElementById('refresh-status');
			refresh.classList.add('hidden');
		}
	}
}

// Current Student Selection
document.addEventListener('DOMContentLoaded', function () {
	const referrals = document.getElementById('referral');

	if (referrals) {
		referrals.addEventListener('change', function () {
			const referralComment = document.querySelector('#referral_comment');
			if (
				this.value === 'Other' ||
				this.value === 'Referred by a friend'
			) {
				referralComment.classList.remove('hidden');
			} else {
				referralComment.classList.add('hidden');
			}
		});
	}

	const refershStatus = document.getElementById('refresh-status');
	if (refershStatus) {
		refershStatus.addEventListener('click', async function (event) {
			const refresh = document.getElementById('refresh-status');
			const status = document.querySelector('.status');
			const statusMessage = document.querySelector('.status-message');
			status.textContent = 'Loading...';
			statusMessage.textContent = '';
			const registrationStatus = await fetchClassBugData(
				1,
				'get_registration_status',
				{
					checkout_job_status_id: refresh.dataset.id,
				},
				'GET'
			);
			setStatus(registrationStatus);
		});
	}

	const container = document.getElementById('currentStudents');
	const bravoStudent = document.querySelector('.btn-bravo-student');

	const fieldIds = [
		'address',
		'cell_phone',
		'city',
		'ec_name',
		'ec_phone',
		'home_phone',
		'referral',
		'referral_comment',
		'special_conditions',
		'state',
		'zip',
	];

	function updateFields(source) {
		fieldIds.forEach((id) => {
			const input = document.querySelector(`#${id}`);
			input.value = source
				? source.getAttribute(`data-${id.replace(/_/g, '-')}`) || ''
				: '';
			if (
				id === 'referral' &&
				(input.value === 'Referred by a friend' ||
					input.value === 'Other')
			) {
				const referralComment =
					document.querySelector('#referral_comment');
				referralComment.classList.remove('hidden');
			}
		});
	}

	if (container) {
		container.addEventListener('click', function (event) {
			const clickedButton = event.target;

			if (!clickedButton.classList.contains('current-student')) return;

			const isActive = clickedButton.classList.contains('active');

			document
				.querySelectorAll('.current-student')
				.forEach((btn) => btn.classList.remove('active'));

			if (isActive) {
				updateFields(null);
				if (bravoStudent) bravoStudent.disabled = true;
			} else {
				clickedButton.classList.add('active');
				updateFields(clickedButton);
				if (bravoStudent) bravoStudent.disabled = false;
			}
		});
	}

	/*
	Complete Registration Step
	*/
	const paymentContainer = document.getElementById('paymentOptions');

	if (paymentContainer) {
		const completeRegistration = document.getElementById(
			'complete-registration'
		);

		const eligibleTypes = ['PARTY', 'BB', 'EVENT', 'CAMP'];

		function updateCompleteRegistrationState() {
			if (!completeRegistration) return;

			const registrationType = getRegistrationType(); // provided by you
			const priceEl = document.getElementById('price');
			const amount = priceEl ? parseFloat(priceEl.value || '0') : 0;

			const giftCardBtn = paymentContainer.querySelector(
				'.payment-card[data-token="gift-card"]'
			);
			const hasGiftCardBtn = !!giftCardBtn;
			const giftCardActive = giftCardBtn
				? giftCardBtn.classList.contains('active')
				: false;
			const giftCardAmount = giftCardBtn
				? parseFloat(giftCardBtn.dataset.amount || '0')
				: 0;

			const activePaymentTypeBtn = paymentContainer.querySelector(
				'.payment-card.active:not([data-token="gift-card"])'
			);
			const hasActivePaymentType = !!activePaymentTypeBtn;

			let enable = false;

			if (!hasGiftCardBtn) {
				// 1️⃣ No gift card present: behave like original – any active payment-card enables completion
				const anyActivePaymentCard = !!paymentContainer.querySelector(
					'.payment-card.active'
				);
				enable = anyActivePaymentCard;
			} else {
				// 4️⃣ Any active non-gift payment-type button by itself activates completion
				if (hasActivePaymentType) {
					enable = true;
				} else if (giftCardActive) {
					// 2️⃣ Gift card alone may be enough for certain registration types
					const isEligibleType =
						eligibleTypes.includes(registrationType);
					if (isEligibleType && amount <= giftCardAmount) {
						// Gift card covers full amount for eligible types
						enable = true;
					} else {
						// 3️⃣ Gift card alone not enough (too small or ineligible type)
						// In this case, user must also select a payment-type button
						// (handled above when hasActivePaymentType becomes true)
						enable = false;
					}
				}
			}

			completeRegistration.disabled = !enable;
		}

		paymentContainer.addEventListener('click', function (event) {
			const clickedButton = event.target.closest('.payment-card');
			if (!clickedButton) return;

			const isGiftCard = clickedButton.dataset.token === 'gift-card';

			if (isGiftCard) {
				// Toggle gift card independently
				clickedButton.classList.toggle('active');
			} else {
				// Payment-type buttons: only one of these active at a time
				const otherPaymentButtons = paymentContainer.querySelectorAll(
					'.payment-card:not([data-token="gift-card"])'
				);
				otherPaymentButtons.forEach((btn) => {
					if (btn !== clickedButton) {
						btn.classList.remove('active');
					}
				});
				clickedButton.classList.toggle('active');
			}

			updateCompleteRegistrationState();
		});
	}

	const costumes = document.getElementById('costumes');

	if (costumes) {
		const btnContact = document.getElementById('btn-contact');

		costumes.addEventListener('change', function () {
			btnContact.disabled = this.value === '';
		});
	}
});

function getAvailableDays(parties) {
	return parties.map((party) => ({
		party_id: party.id,
		name: party.name,
		price: party.price,
		deposit_amount: party.deposit_amount,
		add_ons: party.add_ons,
		available_days: getAvailableDaysForParty(party), // the detailed logic
	}));
}

function getAvailableDaysForParty(party) {
	let startDate = DateTime.fromISO(party.start_date);
	const today = DateTime.now().startOf('day');

	// If the start date is in the past, use today instead
	if (startDate < today) {
		startDate = today;
	}

	// Calculate the end date as the minimum of (start + lead_up weeks) and party.end_date
	const leadUpEndDate = startDate.plus({ weeks: party.lead_up });
	const finalEndDate = DateTime.fromISO(party.end_date);
	const endDate = leadUpEndDate < finalEndDate ? leadUpEndDate : finalEndDate;

	const omitDays = new Set(party.omit_days);
	const durationMinutes = party.duration / 60;
	const incrementMinutes = 30;

	const availableDays = [];

	for (let date = startDate; date <= endDate; date = date.plus({ days: 1 })) {
		const isoDate = date.toISODate();

		if (omitDays.has(isoDate)) continue;

		const dayOfWeek = date.weekday % 7; // Sunday = 0, Saturday = 6
		const slot = party.rental_slots.find(
			(rs) => rs.rental_slot_day === dayOfWeek
		);

		if (slot) {
			const startTime = DateTime.fromISO(
				`${isoDate}T${slot.rental_slot_start_time}`
			);
			const endTime = DateTime.fromISO(
				`${isoDate}T${slot.rental_slot_end_time}`
			);

			const slots = [];
			for (
				let time = startTime;
				time.plus({ minutes: durationMinutes }) <= endTime;
				time = time.plus({ minutes: incrementMinutes })
			) {
				slots.push({
					start: time.toFormat('h:mm a'),
					end: time
						.plus({ minutes: durationMinutes })
						.toFormat('h:mm a'),
				});
			}

			if (slots.length > 0) {
				availableDays.push({ date: isoDate, slots });
			}
		}
	}

	return availableDays;
}

/*
Newsletter Subscription
 */

document.addEventListener('DOMContentLoaded', () => {
	const forms = document.querySelectorAll('[data-newsletter]');
	const slug = document.getElementById('location_selector')?.value.trim();

	forms.forEach((form) => {
		const input = form.querySelector('input[type="email"]');
		const button = form.querySelector('button');
		const originalButtonText = button.textContent;

		form.addEventListener('submit', (event) => {
			event.preventDefault();

			const email = input.value.trim();

			if (!validateEmail(email)) {
				alert('Please enter a valid email address.');
				return;
			}

			// Disable UI and show "Sending"
			input.disabled = true;
			button.disabled = true;
			button.textContent = 'Sending...';

			fetchClassBugDataNewsletter(email, slug)
				.then((data) => {
					form.innerHTML =
						'<p class="font-sans text-md">You have successfully subscribed!</p>';
				})
				.catch((error) => {
					console.error(error);
					alert(
						'There was an error submitting your email. Please try again.'
					);

					// Re-enable UI
					input.disabled = false;
					button.disabled = false;
					button.textContent = originalButtonText;
				});
		});
	});
});

function validateEmail(email) {
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(String(email).toLowerCase());
}

function fetchClassBugDataNewsletter(email, slug) {
	return new Promise((resolve, reject) => {
		fetch('/tutuschooldev/wp-admin/admin-ajax.php', {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: new URLSearchParams({
				action: 'get_classbug_newsletter',
				email: email,
				slug: slug,
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.success) {
					resolve(data.data);
				} else {
					reject(data);
				}
			})
			.catch((error) => reject(error));
	});
}

/*
Masonry CTA
 */
const mm = gsap.matchMedia();

mm.add('(prefers-reduced-motion: no-preference)', () => {
	document.addEventListener('scroll', () => {
		document.querySelectorAll('.masonry-cta-block').forEach((section) => {
			const sectionRect = section.getBoundingClientRect();
			const sectionTop = sectionRect.top;
			const sectionHeight = sectionRect.height;
			const windowHeight = window.innerHeight;

			if (sectionTop < windowHeight && sectionTop + sectionHeight > 0) {
				const scrollY = window.scrollY - section.offsetTop;
				section.querySelectorAll('[data-speed]').forEach((el) => {
					const speed = parseFloat(el.getAttribute('data-speed'));
					el.style.transform = `translateY(${scrollY * speed}px)`;
				});
			}
		});
	});
});

/*
Careers Load More
 */
document.addEventListener('DOMContentLoaded', function () {
	const loadMoreBtn = document.getElementById('load-more');
	const postings = document.querySelectorAll(
		'#postings-wrapper [data-state].hidden'
	);

	if (loadMoreBtn) {
		loadMoreBtn.addEventListener('click', function () {
			postings.forEach((el) => {
				el.style.opacity = 0;
				el.classList.remove('hidden');
				setTimeout(() => {
					el.style.transition = 'opacity 0.4s ease';
					el.style.opacity = 1;
				}, 10);
			});

			loadMoreBtn.style.transition = 'opacity 0.4s ease';
			loadMoreBtn.style.opacity = 0;
			setTimeout(() => {
				loadMoreBtn.style.display = 'none';
			}, 400);
		});
	}
});

document.addEventListener('DOMContentLoaded', function () {
	const popup = document.getElementById('global-popup');
	if (!popup) return;

	const closeBtn = document.getElementById('popup-close');
	const COOKIE_NAME = 'hide_global_popup';
	const COOKIE_DAYS = 30;
	const DELAY_MS = 10000; // 10 seconds

	const setCookie = (name, value, days) => {
		const expires = new Date(Date.now() + days * 864e5).toUTCString();
		document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
	};

	const getCookie = (name) => {
		return document.cookie
			.split('; ')
			.find((row) => row.startsWith(name + '='))
			?.split('=')[1];
	};

	const disableScroll = () => {
		document.body.classList.add('overflow-hidden');
	};

	const enableScroll = () => {
		document.body.classList.remove('overflow-hidden');
	};

	if (!getCookie(COOKIE_NAME)) {
		setTimeout(() => {
			popup.classList.remove('opacity-0', 'pointer-events-none');
			disableScroll();

			// Trigger fade animation manually on .fade elements
			const popupFadeEls = popup.querySelectorAll('.fade');
			if (popupFadeEls.length) {
				gsap.set(popupFadeEls, { y: 40, opacity: 0 });

				gsap.to(popupFadeEls, {
					opacity: 1,
					y: 0,
					stagger: 0.15,
					duration: 0.6,
					ease: 'power2.out',
				});
			}
		}, DELAY_MS);
	}

	closeBtn.addEventListener('click', () => {
		popup.classList.add('opacity-0', 'pointer-events-none');
		enableScroll();
		setCookie(COOKIE_NAME, 'true', COOKIE_DAYS);
	});
});

/*
Phone Format
 */

document.addEventListener('DOMContentLoaded', () => {
	const telInputs = document.querySelectorAll('input[type="tel"]');
	const businessName = document
		.querySelector('#business_slug')
		?.value?.toLowerCase();

	telInputs.forEach((input) => {
		input.addEventListener('input', () => {
			// Remove all non-digits
			let numbers = input.value.replace(/\D/g, '');

			let formatted = '';

			if (businessName === 'salisbury') {
				// Limit to 11 digits for UK
				numbers = numbers.substring(0, 11);

				if (numbers.length >= 1) {
					formatted += numbers.substring(0, 4);
				}
				if (numbers.length >= 5) {
					formatted += ' ' + numbers.substring(4, 7);
				}
				if (numbers.length >= 8) {
					formatted += ' ' + numbers.substring(7, 11);
				}
			} else {
				// Limit to 10 digits for US
				numbers = numbers.substring(0, 10);

				if (numbers.length >= 1) {
					formatted += '(' + numbers.substring(0, 3);
				}
				if (numbers.length >= 4) {
					formatted += ') ' + numbers.substring(3, 6);
				}
				if (numbers.length >= 7) {
					formatted += '-' + numbers.substring(6, 10);
				}
			}

			input.value = formatted;
		});
	});
});

document.addEventListener('DOMContentLoaded', () => {
	const logoutButtons = document.querySelectorAll('[data-logout]');

	logoutButtons.forEach((button) => {
		button.addEventListener('click', (event) => {
			event.preventDefault();
			if (
				window.ClassbugAPI &&
				typeof window.ClassbugAPI.LogoutUser === 'function'
			) {
				window.ClassbugAPI.LogoutUser();
			} else {
				console.warn('ClassbugAPI.LogoutUser is not available.');
			}
		});
	});
});

/*
Gift Cards
*/
let isGiftCardValid = false;

async function redeemGiftCard() {
	try {
		const input = document.getElementById('gift_card');
		const data = await fetchClassBugData(
			1,
			'redeem_gift_card',
			{
				redemption_code: input.value,
			},
			'POST'
		);

		// If API returned an error object, throw so caller can handle it
		if (data && data.error) {
			throw new Error(data.error);
		}
		/*
		const data = {
			message: 'Gift card successfully redeemed',
			user_name: 'Doug Vander Meulen',
			user_id: 1837,
			store_credit_balance: 15000,
		};
		*/
		// Otherwise we expect the success object (message, user_name, user_id, store_credit_balance)
		return data;
	} catch (error) {
		console.error('API Error:', error);
		throw error;
	}
}

const giftCardButton = document.getElementById('check_gift_card');

if (giftCardButton) {
	document
		.getElementById('check_gift_card')
		.addEventListener('click', async function () {
			const button = this;
			const input = document.getElementById('gift_card');
			const messageLabel = document.getElementById('gift_card_message');

			const userInput = input.value.trim().toLowerCase();
			isGiftCardValid = false;

			if (!userInput) {
				messageLabel.textContent = 'Please enter a gift card number';
				return;
			}

			button.textContent = 'Checking';
			messageLabel.textContent = '';

			try {
				const result = await redeemGiftCard(); // success object or error thrown

				// Format the amount from store_credit_balance
				// assuming store_credit_balance is in cents (15000 -> 150.00)
				const amount = (result.store_credit_balance / 100).toFixed(2);

				const paymentOptions =
					document.getElementById('paymentOptions');
				if (paymentOptions) {
					const emptyMessage =
						paymentOptions.querySelector('p.eyebrow');

					if (emptyMessage) {
						paymentOptions.innerHTML = '';
					}

					const amount = (result.store_credit_balance / 100).toFixed(
						2
					);

					// Look for an existing gift card button
					const existingGiftCardBtn = paymentOptions.querySelector(
						'[data-token="gift-card"]'
					);

					if (existingGiftCardBtn) {
						// Update the button text
						existingGiftCardBtn.textContent = `Store Credit $${amount}`;
					} else {
						// Otherwise create and append a new one
						const btn = document.createElement('button');
						btn.dataset.token = 'gift-card';
						btn.dataset.amount = amount;
						btn.className =
							'btn btn-purple payment-card no-icon relative';
						btn.innerHTML = `
						<svg xmlns="http://www.w3.org/2000/svg"
							class="w-[30px] absolute left-4 transition-all"
							viewBox="0 0 640 640">
							<path d="M320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576zM438 209.7C427.3 201.9 412.3 204.3 404.5 215L285.1 379.2L233 327.1C223.6 317.7 208.4 317.7 199.1 327.1C189.8 336.5 189.7 351.7 199.1 361L271.1 433C276.1 438 282.9 440.5 289.9 440C296.9 439.5 303.3 435.9 307.4 430.2L443.3 243.2C451.1 232.5 448.7 217.5 438 209.7z"/>
						</svg>
						Store Credit $${amount}
						`;
						paymentOptions.appendChild(btn);

						const giftCardMessage =
							document.querySelector('#giftcard');
						giftCardMessage.classList.remove('hidden');
					}
				}

				messageLabel.innerHTML = `
				<strong>${result.message},</strong> $${amount} has been applied to your account.
				`;

				isGiftCardValid = true;
				//input.disabled = true;
				button.textContent = 'Add Another';
			} catch (error) {
				console.error(error);
				messageLabel.textContent =
					error.message || 'Error redeeming gift card.';
				button.textContent = 'Submit';
			}
		});
}

/*
Lazy Load CSS Background Images
*/
document.addEventListener('DOMContentLoaded', () => {
	const lazyBgs = document.querySelectorAll('.lazy-bg');
	if (lazyBgs.length > 0) {
		const bgObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const el = entry.target;
					const bg = el.getAttribute('data-bg');
					if (bg) {
						if (bg.includes('url(')) {
							el.style.background = bg;
						} else {
							el.style.backgroundImage = `url('${bg}')`;
						}
						el.classList.remove('lazy-bg');
					}
					observer.unobserve(el);
				}
			});
		}, { rootMargin: '200px' });

		lazyBgs.forEach((el) => bgObserver.observe(el));
	}
});



/* ==========================================================================
   EXTRACTED BLOCK JAVASCRIPT MODULES
   ========================================================================== */





/* Horizontal Scroll Block */
const initHorizontalScroll = () => {
	const horizontalScrollSections = document.querySelectorAll('.horizontal-scroll-images');

	horizontalScrollSections.forEach((section) => {
		const scrollWrapper = section.querySelector('.scroll-wrapper');
		if (!scrollWrapper) return;

		const updateDimensions = () => {
			const totalScroll = scrollWrapper.scrollWidth - scrollWrapper.clientWidth;
			const sectionHeight = scrollWrapper.scrollWidth;
			section.style.height = sectionHeight + 'px';
			return { totalScroll, sectionHeight };
		};

		let { totalScroll, sectionHeight } = updateDimensions();

		const onScroll = () => {
			const rect = section.getBoundingClientRect();
			const top = rect.top;
			const bottom = rect.bottom;

			if (top <= 0 && bottom >= 0) {
				const scrollProgress = Math.min(Math.abs(top) / (sectionHeight - window.innerHeight), 1);
				scrollWrapper.scrollLeft = scrollProgress * totalScroll;
			}
		};

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', () => {
			const dims = updateDimensions();
			totalScroll = dims.totalScroll;
			sectionHeight = dims.sectionHeight;
			onScroll();
		});

		// Recalculate when cards/images finish loading so scroll height matches true width
		section.querySelectorAll('img, .lazy-bg').forEach((el) => {
			if (el.tagName === 'IMG' && !el.complete) {
				el.addEventListener('load', () => {
					const dims = updateDimensions();
					totalScroll = dims.totalScroll;
					sectionHeight = dims.sectionHeight;
				});
			}
		});
	});
};

if (document.readyState !== 'loading') {
	initHorizontalScroll();
} else {
	document.addEventListener('DOMContentLoaded', initHorizontalScroll);
}


/* Job Posting Sticky Header Observer */
document.addEventListener('DOMContentLoaded', () => {
	const stickyContainer = document.querySelector('.sticky.top-0.z-10');
	if (!stickyContainer) return;

	const toggleStuck = () => {
		const scrolled = window.scrollY || window.pageYOffset;
		stickyContainer.classList.toggle('is-stuck', scrolled > 150);
	};

	window.addEventListener('scroll', toggleStuck, { passive: true });
	toggleStuck(); // run on load
});

/* Tutu TV Block Tag Filtering & Password Protection */
document.addEventListener('DOMContentLoaded', function () {
	const tvBlock = document.querySelector('.block-tv, .tv-block');
	if (!tvBlock) return;

	// Tags live inside .block-tv; cards live in a sibling section inside .protected-block-wrapper
	const wrapper = tvBlock.closest('.protected-block-wrapper') || tvBlock.parentElement;

	const tags = tvBlock.querySelectorAll('.tag');
	const items = wrapper.querySelectorAll('.blog-card[data-tags]');
	let activeTag = null;

	tags.forEach(tag => {
		tag.addEventListener('click', function () {
			const selectedTag = this.getAttribute('data-tag');

			if (activeTag === selectedTag || this.textContent.trim() === 'All') {
				resetAll();
				return;
			}

			activeTag = selectedTag;
			updateTags(this);
			filterItems(selectedTag);
		});
	});

	function updateTags(activeElement) {
		tags.forEach(tag => {
			tag.style.opacity = tag === activeElement ? '1' : '0.5';
		});
	}

	function filterItems(tag) {
		items.forEach(item => {
			const itemTags = item.getAttribute('data-tags')?.split(' ') || [];
			const matches = itemTags.includes(tag);

			item.style.opacity = '0';
			setTimeout(() => {
				item.style.display = matches ? 'flex' : 'none';
				item.style.opacity = '1';
			}, 500);
		});
	}

	function resetAll() {
		activeTag = null;
		tags.forEach(tag => tag.style.opacity = '1');
		items.forEach(item => {
			item.style.opacity = '0';
			setTimeout(() => {
				item.style.display = 'flex';
				item.style.opacity = '1';
			}, 500);
		});
	}

	// Password-protected content handler
	wrapper.querySelectorAll('.password-protect-form').forEach(function (form) {
		form.addEventListener('submit', function (e) {
			e.preventDefault();

			const passwordInput = form.querySelector('input[name="block_password_input"]');
			const errorMessage = form.querySelector('.error-message');
			const submitButton = form.querySelector('button[type="submit"]');
			const hiddenContent = wrapper.querySelector('.hidden-protected-content');
			const originalButtonText = submitButton.textContent;

			passwordInput.disabled = true;
			submitButton.disabled = true;
			submitButton.textContent = 'Loading...';

			const formData = new FormData();
			formData.append('action', 'check_block_password');
			formData.append('password', passwordInput.value);
			if (typeof themeData !== 'undefined' && themeData.blogId) {
				formData.append('blog_id', themeData.blogId);
			}

			const ajaxUrl = (typeof themeData !== 'undefined' && themeData.ajaxUrl)
				? themeData.ajaxUrl
				: '/wp-admin/admin-ajax.php';

			fetch(ajaxUrl, { method: 'POST', body: formData })
				.then(response => response.json())
				.then(data => {
					if (data.success) {
						form.style.display = 'none';
						const protectedContent = wrapper.querySelector('.hidden-protected-content');
						if (protectedContent) {
							protectedContent.classList.remove('hidden-protected-content');
							protectedContent.classList.add('protected-content');
							protectedContent.style.display = 'block';
							protectedContent.style.opacity = 0;
							protectedContent.style.transition = 'opacity 0.5s ease';
							protectedContent.removeAttribute('aria-hidden');
							protectedContent.removeAttribute('inert');
							setTimeout(() => { protectedContent.style.opacity = 1; }, 10);
						}
					} else {
						passwordInput.disabled = false;
						submitButton.disabled = false;
						submitButton.textContent = originalButtonText;
						errorMessage.style.display = 'block';
						errorMessage.textContent = data.data.message || 'Password incorrect.';
					}
				})
				.catch(error => {
					console.error('Error:', error);
					passwordInput.disabled = false;
					submitButton.disabled = false;
					submitButton.textContent = originalButtonText;
					errorMessage.style.display = 'block';
					errorMessage.textContent = 'Something went wrong. Please try again.';
				});
		});
	});
});

/* Wave Text Block Lottie & Animations */
document.addEventListener('DOMContentLoaded', () => {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	window.scrollTo(0, 0);

	const waveBlock = document.querySelector('.block-wave-text, .wave-text-block');
	if (!waveBlock) return;

	const leftEl = document.getElementById('sparkleWaveLeft');
	const rightEl = document.getElementById('sparkleWaveRight');

	if (leftEl && typeof themeData !== 'undefined' && themeData.sparkle05) {
		lottie.loadAnimation({
			container: leftEl,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			path: themeData.sparkle05,
		});
	}
	if (rightEl && typeof themeData !== 'undefined' && themeData.sparkle05) {
		lottie.loadAnimation({
			container: rightEl,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			path: themeData.sparkle05,
		});
	}
});


/* Block: Franchise Quotes — Scroll Pin Animation */
document.addEventListener('DOMContentLoaded', () => {
	if (!document.querySelector('.franchise-quotes')) return;
	window.requestIdle(() => {
		const mm = gsap.matchMedia();

		mm.add({
			isDesktop: "(min-width: 976px)",
			isReduce: "(prefers-reduced-motion: reduce)"
		}, (context) => {
			let { isDesktop, isReduce } = context.conditions;

			if (isDesktop) {
				const cards = gsap.utils.toArray('.franchise-quotes .quote-card');
				const totalCards = cards.length;

				gsap.set(cards, { autoAlpha: 0, y: isReduce ? 0 : 100 });

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: '.franchise-quotes .scroll-space',
						start: 'top top',
						end: `+=${totalCards * 200}%`,
						scrub: true,
						pin: '.franchise-quotes .content-pin',
					}
				});

				cards.forEach((card, i) => {
					const next = cards[i + 1];

					timeline.to(card, {
						autoAlpha: 1,
						y: 0,
						duration: 0.5,
						ease: 'power2.out'
					});

					if (next) {
						timeline.to(card, {
							autoAlpha: 0,
							y: isReduce ? 0 : -50,
							duration: 0.5
						}, '+=0.5');
					}
				});
			}
		});

		ScrollTrigger.refresh();
	}); // end requestIdle
});

/* Block: What We Offer — Scroll Pin Animation */
document.addEventListener('DOMContentLoaded', () => {
	if (!document.querySelector('.what-we-offer')) return;
	window.requestIdle(() => {
		const mm = gsap.matchMedia();

		mm.add({
			isDesktop: "(min-width: 976px)",
			isReduce: "(prefers-reduced-motion: reduce)"
		}, (context) => {
			let { isDesktop, isReduce } = context.conditions;

			if (isDesktop) {
				const cards = gsap.utils.toArray('.what-we-offer .offer-card');
				const totalCards = cards.length;

				gsap.set(cards, { autoAlpha: 0, y: isReduce ? 0 : 100 });

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: '.what-we-offer .scroll-space',
						start: 'top top',
						end: `+=${totalCards * 200}%`,
						scrub: true,
						pin: '.what-we-offer .content-pin',
					}
				});

				cards.forEach((card, i) => {
					const next = cards[i + 1];

					timeline.to(card, {
						autoAlpha: 1,
						y: 0,
						duration: 0.5,
						ease: 'power2.out'
					});

					if (next) {
						timeline.to(card, {
							autoAlpha: 0,
							y: isReduce ? 0 : -50,
							duration: 0.5
						}, '+=0.5');
					}
				});
			}
		});

		ScrollTrigger.refresh();
	}); // end requestIdle
});
